unit View.Produtos.List;

interface

uses
  System.SysUtils, System.Classes, WEBLib.Graphics, WEBLib.Forms, WEBLib.Dialogs,
  Vcl.Controls, Vcl.StdCtrls, Math, WEBLib.StdCtrls, Web, JS, WEBLib.Lists,
  App.Types, WEBLib.Controls, WEBLib.Grids, Data.DB, XData.Web.Dataset,
  WEBLib.DBCtrls, WEBLib.DB, WEBLib.ExtCtrls, XData.Web.JsonDataset,
  Grid.Plugins, Crud.Utils, UConstantes, System.StrUtils, UHelperServer, UUtils,
  UPersonalizacao_Tabela.Interfaces, UPersonalizacao_Tabela, XData.Web.Client,
  UClientTablePagination;

type
  TFViewProdutosList = class(TForm)
    ProdutosDataset: TXDataWebDataSet;
    ProdutosDatasetid: TIntegerField;
    ProdutosDatasetnome: TStringField;
    ProdutosDatasetcodigo_barras: TStringField;
    ProdutosDatasetestoque: TFloatField;
    ProdutosDatasetpreco_custo: TFloatField;
    ProdutosDatasetpreco_venda: TFloatField;
    ProdutosDatasetpreco_promocional: TFloatField;
    ProdutosDatasetpreco_padrao: TIntegerField;
    ProdutosDatasetstatus: TIntegerField;
    ProdutosDatasetcadastro: TDateTimeField;
    ProdutosDatasetcodigo_interno: TIntegerField;
    ProdutosDatasetexcluido: TBooleanField;
    ProdutosDatasetinclusao: TDateTimeField;
    ProdutosDatasetalteracao: TDateTimeField;
    ProdutosDatasetexclusao: TDateTimeField;
    WebDBTableControl1: TDBTableControl;
    WebDataSource: TDataSource;
    cbPageSize: TComboBox;
    edSearch: TEdit;
    lbPaginationInfo: TLabel;
    lcPaginator: TListControl;
    tmrConsulta: TTimer;
    btnExportarExcel: TButton;
    ProdutosDatasetsubgruponome: TStringField;
    ProdutosDatasetsubgrupogruponome: TStringField;
    ProdutosDatasetunidadesigla: TXDataWebDatasetField;
    ProdutosDatasetpreco: TFloatField;
    ProdutosDatasetpromocao: TBooleanField;
    cbbProdutoStatus: TComboBox;
    cbbProdutoPrecoPadrao: TComboBox;
    cbxProdutosDesativados: TCheckBox;
    ProdutosDatasetaliadoNome_Fantasia: TStringField;
    cbxProdutosExcluidos: TCheckBox;
    ProdutosDatasetassociacaofsprodimagem: TXDataWebDatasetField;
    ProdutosDatasetassociacaostatus: TXDataWebDatasetField;
    ProdutosDatasetncmncm: TStringField;
    cdsProdutosAssociar: TXDataWebDataSet;
    cdsProdutosAssociarcodigo_interno: TStringField;
    cdsProdutosAssociarcodigo_barras: TStringField;
    cdsProdutosAssociarnome: TStringField;
    ProdutosDatasetselecionado: TBooleanField;
    cdsProdutosAssociarid: TIntegerField;
    tblProdutosAssociar: TDBTableControl;
    dtsProdutosAssociar: TDataSource;
    btnSelecionadosTab: TButton;
    cdsProdutosAssociarstatus: TStringField;
    cdsProdutosAssociarimagem: TStringField;
    cdsProdutosAssociarnome_fs_prod: TStringField;
    cdsProdutosAssociarcodigo_barras_fs_prod: TStringField;
    ProdutosDatasetassociacaofsprodnome: TStringField;
    ProdutosDatasetassociacaofsprodcodigo_barras: TStringField;
    ProdutosDatasetassociacaoimagem_aprovacao: TStringField;
    XDataWebSugestaoProdutos: TXDataWebClient;
    cdsProdutosAssociarsugestao_carregada: TBooleanField;
    ProdutosDatasetassociacaofsprodid: TIntegerField;
    cdsProdutosAssociarfs_prod_id: TStringField;
    btnMarcarDesmarcarTodos: TButton;
    XDataWebSugestaoImagem: TXDataWebClient;
    btnPesquisarImagem: TButton;
    edtCodigoProduto: TEdit;
    edtNomeProduto: TEdit;
    btnSalvarImagem: TButton;
    btnRemoverAssociacao: TButton;
    tblProdutosElasticSearch: TDBTableControl;
    cdsProdutosElasticSearch: TXDataWebDataSet;
    StringField2: TStringField;
    StringField3: TStringField;
    IntegerField1: TIntegerField;
    StringField5: TStringField;
    dtsProdutosElasticSearch: TDataSource;
    edtCodigoProdutoAssociadoModal: TEdit;
    edtNomeProdutoAssociadoModal: TEdit;
    edtCodBarrasProdutoAssociadoModal: TEdit;
    edtProdutosElasticSearch: TEdit;
    btnPesquisarProdutosElasticSearch: TButton;
    XDataWebListaElasticSearch: TXDataWebClient;
    btnSolicitarCadastroProduto: TButton;
    XDataWebListaElasticSearchCodBarras: TXDataWebClient;
    cdsProdutosAssociaratualizou_status: TBooleanField;
    cbbTipoPesquisa: TComboBox;
    cbPageSizeSelecionados: TComboBox;
    cbPageSizeElasticSearch: TComboBox;
    cdsProdutosAssociarimagem_original: TStringField;
    edtPesquisarSelecionados: TEdit;
    btnSalvarAlteracoes: TButton;
    XDataWebAssociarProdutos: TXDataWebClient;
    cdsProdutosAssociarstatus_original: TStringField;
    ProdutosDatasetdbassociar_produtos: TBooleanField;
    cbbStatusAssociacao: TComboBox;
    cdsProdutosAssociardata_base_id: TIntegerField;
    ProdutosDatasetdata_base_id: TIntegerField;
    edtCodigoBarrasGerado: TEdit;
    procedure WebFormCreate(Sender: TObject);
    procedure WebDBTableControl1GetCellChildren(Sender: TObject; ACol, ARow: Integer; AField: TField; AValue: string; AElement: TJSHTMLElementRecord);
    procedure cbPageSizeChange(Sender: TObject);
    procedure edSearchKeyDown(Sender: TObject; var Key: Word; Shift: TShiftState);
    procedure edSearchKeyUp(Sender: TObject; var Key: Word; Shift: TShiftState);
    procedure tmrConsultaTimer(Sender: TObject);
    procedure WebDBTableControl1GetCellClass(Sender: TObject; ACol, ARow: Integer; AField: TField; AValue: string; var AClassName: string);
    procedure WebDBTableControl1GetCellData(Sender: TObject; ACol, ARow: Integer; AField: TField; var AValue: string);
    procedure btnExportarExcelClick(Sender: TObject);
    procedure cbbProdutoStatusChange(Sender: TObject);
    procedure cbbProdutoPrecoPadraoChange(Sender: TObject);
    procedure cbPageSizeSelecionadosChange(Sender: TObject);
    procedure cbxProdutosDesativadosClick(Sender: TObject);
    procedure cbxProdutosExcluidosClick(Sender: TObject);
    procedure edtPesquisarSelecionadosKeyUp(Sender: TObject; var Key: Word;
      Shift: TShiftState);
    procedure tblProdutosAssociarGetCellClass(Sender: TObject; ACol, ARow: Integer; AField: TField; AValue: string; var AClassName: string);
    procedure tblProdutosAssociarGetCellChildren(Sender: TObject; ACol, ARow: Integer; AField: TField; AValue: string; AElement: TJSHTMLElementRecord);
    procedure tblProdutosAssociarClickCell(Sender: TObject; ACol,
      ARow: Integer);
    procedure XDataWebSugestaoProdutosError(Error: TXDataClientError);
    procedure XDataWebSugestaoProdutosLoad(Response: TXDataClientResponse);
    [async]
    procedure btnMarcarDesmarcarTodosClick(Sender: TObject); async;
    procedure XDataWebSugestaoImagemError(Error: TXDataClientError);
    procedure XDataWebSugestaoImagemLoad(Response: TXDataClientResponse);
    procedure btnPesquisarImagemClick(Sender: TObject);
    procedure btnSalvarImagemClick(Sender: TObject);
    [async]
    procedure btnRemoverAssociacaoClick(Sender: TObject); async;
    procedure btnSelecionadosTabClick(Sender: TObject);
    procedure tblProdutosElasticSearchGetCellClass(Sender: TObject; ACol, ARow: Integer; AField: TField; AValue: string; var AClassName: string);
    procedure tblProdutosElasticSearchGetCellChildren(Sender: TObject; ACol, ARow: Integer; AField: TField; AValue: string; AElement: TJSHTMLElementRecord);
    procedure XDataWebListaElasticSearchError(Error: TXDataClientError);
    procedure XDataWebListaElasticSearchLoad(Response: TXDataClientResponse);
    procedure btnPesquisarProdutosElasticSearchClick(Sender: TObject);
    procedure XDataWebListaElasticSearchCodBarrasError(Error: TXDataClientError);
    procedure XDataWebListaElasticSearchCodBarrasLoad(Response: TXDataClientResponse);
    procedure btnSolicitarCadastroProdutoClick(Sender: TObject);
    procedure tblProdutosElasticSearchClickCell(Sender: TObject; ACol,
      ARow: Integer);
    procedure cbPageSizeElasticSearchChange(Sender: TObject);
    [async]
    procedure btnSalvarAlteracoesClick(Sender: TObject); async;
    procedure XDataWebAssociarProdutosError(Error: TXDataClientError);
    procedure XDataWebAssociarProdutosLoad(Response: TXDataClientResponse);
    procedure ProdutosDatasetAfterOpen(DataSet: TDataSet);
    procedure cbbStatusAssociacaoChange(Sender: TObject);
  private
    FEditProc: TEditProc;
    FGridPlugin: TGridPlugin;
    FPersonalizacaoTabela: IPersonalizacao_Tabela;
    FImagemSelecionada,
    FIdFsProdAtual: string;
    FSortAssociarCampo: string;
    FSortAssociarDesc: Boolean;
    FSortElasticCampo: string;
    FSortElasticDesc,
    FProdutosAssociacaoPromocoes: Boolean;

    function GetFiltro: string;
    procedure Filtrar;
    procedure AbrirModalAssociacao;
    function MarcarProduto(pCodigoProduto: Integer = 0) : Boolean;
    procedure RemoverImagemProdutoAtual;
    procedure AtualizarPreviewImagem(const pImagemSrc: string);
    procedure LimparSelecaoSeletorImagens;
    procedure AtualizarCaptionMarcarDesmarcarTodos(const pMarcarTodos: Boolean);
    procedure SetQuantidadeSelecionados;
    procedure SetProdutosElasticSearch(pArray: TJSArray);
    function VerificarQuantidadeMaximaSelecionada : Boolean;
    procedure VerificarBotaoMarcarDesmarcarTodos;
    procedure AtualizarTabelaAssociar(const pPage: Integer = 1);
    procedure AtualizarTabelaElasticSearch(const pPage: Integer = 1);
    procedure SetProdutoArray(pAtualizouImagem : Boolean; var pArray : TJSArray);
    procedure LimparCdsProdutosAprovacao(pAtualizarDados : Boolean = False);
    function GerarCodigoBarrasNovoFsProduto(pCodigoInterno, pBancoId : Integer;
      pCodigoBarras : string) : string;
    procedure ExibirMensagemInformacao(const pMensagem: string);
  public
    class function CreateForm(AElementID: string; AShowEditProc: TEditProc): TForm;
  protected procedure LoadDFMValues; override; end;

var
  FViewProdutosList: TFViewProdutosList;

implementation

uses
  ConnectionModule;

{$R *.dfm}

{ TFViewProdutosList }

procedure TFViewProdutosList.btnExportarExcelClick(Sender: TObject);
begin
  TUtils.ExportarDadosExcel(ProdutosDataset, WebDBTableControl1, FGridPlugin.FDatasetPlugin.FDataset.QueryString, FGridPlugin.FQuantidadeRegistrosBusca);
end;

procedure TFViewProdutosList.btnMarcarDesmarcarTodosClick(Sender: TObject);
var
  lProdutosMarcados : Boolean;
  lQuantidadeMarcada : Integer;
begin
  TUtils.ChamarDivLoading;

  if btnMarcarDesmarcarTodos.Tag = 0 then
  begin
    lQuantidadeMarcada := 0;

    ProdutosDataset.DisableControls;
    ProdutosDataset.First;

    try
      while not ProdutosDataset.Eof do
      begin
        if VerificarQuantidadeMaximaSelecionada then
          Break;

        if MarcarProduto then
          Inc(lQuantidadeMarcada);

        ProdutosDataset.Next;
      end;
    finally
      ProdutosDataset.EnableControls;
    end;

    if lQuantidadeMarcada > 0 then
    begin
      AtualizarCaptionMarcarDesmarcarTodos(False);
      btnMarcarDesmarcarTodos.Tag := 1;
    end
    else
    begin
      TUtils.ChamarMensagemDialog(TTipoDialogo.INFORMACAO, 'Não foi possível marcar os produtos!' +
        sLineBreak + 'Produtos pertencem a uma banco não associado!');
    end;
  end
  else
  begin
    lQuantidadeMarcada := 1;
    AtualizarCaptionMarcarDesmarcarTodos(True);
    btnMarcarDesmarcarTodos.Tag := 0;
    LimparCdsProdutosAprovacao;
  end;

  if lQuantidadeMarcada = 0 then
    TUtils.OcultarDivLoading
  else
  begin
    Await(FGridPlugin.Load);
    SetQuantidadeSelecionados;
  end;
end;

procedure TFViewProdutosList.AtualizarCaptionMarcarDesmarcarTodos(const pMarcarTodos: Boolean);
var
  lCaption: string;
begin
  if pMarcarTodos then
    lCaption := 'Marcar Todos'
  else
    lCaption := 'Desmarcar Todos';

  btnMarcarDesmarcarTodos.Caption := lCaption;

  if Assigned(btnMarcarDesmarcarTodos.ElementHandle) then
    btnMarcarDesmarcarTodos.ElementHandle.innerHTML := '<span class="btn-label"><i class="fas fa-check"></i></span>   ' + lCaption;
end;

procedure TFViewProdutosList.btnPesquisarImagemClick(Sender: TObject);
var
  lJson: TJSObject;
  lArray: TJSArray;
begin
  if Trim(edtNomeProduto.Text).IsEmpty then
  begin
    TUtils.ChamarMensagemDialog(TTipoDialogo.INFORMACAO, 'Insira o nome do produto para pesquisar!');
    Exit;
  end;

  TUtils.ChamarDivLoading;
  lArray := TJSArray.new;
  lJson := TJSObject.New;
  lJson['nome'] := edtNomeProduto.Text;
  lJson['codigo'] := edtCodigoProduto.Text;
  lJson['size'] := 5;
  lArray.push(lJson);

  FImagemSelecionada := EmptyStr;

  XDataWebSugestaoImagem.RawInvoke('IService.GetSugestaoImagemProdutos', [lArray]);
end;

procedure TFViewProdutosList.btnPesquisarProdutosElasticSearchClick(Sender: TObject);
var
  lJson: TJSObject;
begin
  if Trim(edtProdutosElasticSearch.Text).IsEmpty then
  begin
    if cbbTipoPesquisa.ItemIndex = 1 then
      TUtils.ChamarMensagemDialog(TTipoDialogo.INFORMACAO, 'Insira o código de barras para pesquisar!')
    else
      TUtils.ChamarMensagemDialog(TTipoDialogo.INFORMACAO, 'Insira o nome do produto para pesquisar!');

    Exit;
  end;

  TUtils.ChamarDivLoading;
  cdsProdutosElasticSearch.Close;
  cdsProdutosElasticSearch.Open;
  lJson := TJSObject.New;

  if cbbTipoPesquisa.ItemIndex = 1 then
    lJson['codigo_barras'] := edtProdutosElasticSearch.Text
  else
    lJson['nome'] := edtProdutosElasticSearch.Text;

  XDataWebListaElasticSearch.RawInvoke('IService.GetProdutosElasticSearchFrontEnd', [lJson]);
end;

procedure TFViewProdutosList.btnRemoverAssociacaoClick(Sender: TObject);
var
  lArray : TJSArray;
  lStatus : string;
  lJson : TJSObject;
begin
  if cdsProdutosAssociar.RecordCount = 0 then
  begin
    TUtils.ChamarMensagemDialog(TTipoDialogo.INFORMACAO, 'Nenhum produto selecionado!');
    Exit;
  end;

  if Await(TUtils.ChamarMensagemDialog(TTipoDialogo.CONFIRMACAO,
    'Tem certeza que deseja remover a associação dos produtos selecionados?')) then
  begin
    TUtils.ChamarDivLoading;

    lArray := TJSArray.New;

    cdsProdutosAssociar.DisableControls;
    cdsProdutosAssociar.First;
    try
      while not cdsProdutosAssociar.Eof do
      begin
        lStatus := cdsProdutosAssociar.FieldByName('status_original').AsString;

        if not lStatus.IsEmpty and (lStatus.ToUpper <> 'NULL')  and (lStatus <> '0') then
        begin
          lJson := TJSObject.New;
          lJson['produto_id'] := cdsProdutosAssociar.FieldByName('id').AsInteger;
          lJson['nome'] := cdsProdutosAssociar.FieldByName('nome').AsString;
          lJson['codigo_barras'] := cdsProdutosAssociar.FieldByName('codigo_barras').AsString;
          lJson['status'] := 0;

          lArray.push(lJson);
        end;

        cdsProdutosAssociar.Next;
      end;
    finally
      cdsProdutosAssociar.EnableControls;
    end;

    if lArray.Length = 0 then
    begin
      TUtils.ChamarMensagemDialog(TTipoDialogo.INFORMACAO, 'Não existem produtos para remover a associação!' +
        sLineBreak + 'Somente produtos com status diferente de <b>desassociado</b> podem ter a  associação removida.');
    end
    else
      XDataWebAssociarProdutos.RawInvoke('IService.AssociarProdutosAliado', [lArray], 'Remover Associacao');
  end;
end;

procedure TFViewProdutosList.RemoverImagemProdutoAtual;
begin
  FImagemSelecionada := EmptyStr;
  LimparSelecaoSeletorImagens;
  AtualizarPreviewImagem('assets/img/produto_sem_imagem.webp');
end;

procedure TFViewProdutosList.SetProdutoArray(pAtualizouImagem: Boolean;
  var pArray: TJSArray);
var
  lJson : TJSObject;
  lStatus : Integer;
begin
  lJson := TJSObject.New;
  lStatus := cdsProdutosAssociar.FieldByName('status').AsInteger;
  lJson['nome'] := cdsProdutosAssociar.FieldByName('nome').AsString;
  lJson['codigo_barras'] := cdsProdutosAssociar.FieldByName('codigo_barras').AsString;

  if Trim(cdsProdutosAssociar.FieldByName('fs_prod_id').AsString).IsEmpty then
    lStatus := 3;

  case lStatus of
    1, 2: lJson['codigo_fs_prod'] := cdsProdutosAssociar.FieldByName('fs_prod_id').AsInteger;
    3:
    begin
      lJson['codigo_barras'] := GerarCodigoBarrasNovoFsProduto(cdsProdutosAssociar.FieldByName('codigo_interno').AsInteger,
        cdsProdutosAssociar.FieldByName('data_base_id').AsInteger, cdsProdutosAssociar.FieldByName('codigo_barras').AsString);
    end;
  end;

  lJson['produto_id'] := cdsProdutosAssociar.FieldByName('id').AsInteger;

  if pAtualizouImagem then
    lJson['imagem'] := cdsProdutosAssociar.FieldByName('imagem').AsString;

  pArray.push(lJson);
end;

procedure TFViewProdutosList.SetProdutosElasticSearch(pArray: TJSArray);
var
  lJsonObject, 
  lJsonProduto: TJSObject;
  lIndice: Integer;
  lImagem: string;
begin
  for lIndice := 0 to pArray.Length - 1 do
  begin
    lJsonObject := TJSObject(pArray[lIndice]);
    lJsonProduto := TJSObject(lJsonObject['_source']);

    cdsProdutosElasticSearch.Append;
    cdsProdutosElasticSearch.FieldByName('id').AsInteger := Integer(lJsonProduto['id']);
    cdsProdutosElasticSearch.FieldByName('nome').AsString := UpperCase(string(lJsonProduto['nome']));
    cdsProdutosElasticSearch.FieldByName('codigo_barras').AsString := string(lJsonProduto['codigo_barras']);

    lImagem := string(lJsonProduto['foto']);

    if not lImagem.IsEmpty and (lImagem.ToUpper <> 'NULL') then
      cdsProdutosElasticSearch.FieldByName('imagem').AsString := lImagem;

    cdsProdutosElasticSearch.Post;
  end;

  AtualizarTabelaElasticSearch(1);
  TUtils.OcultarDivLoading;
end;

procedure TFViewProdutosList.SetQuantidadeSelecionados;
begin
  if not FSortAssociarCampo.IsEmpty then
    TClientTablePagination.SortDataSet(cdsProdutosAssociar, FSortAssociarCampo,
      FSortAssociarDesc);

  btnSelecionadosTab.Caption := 'Associar (' + cdsProdutosAssociar.RecordCount.ToString + ') Produto(s)';
  AtualizarTabelaAssociar(0);
end;

procedure TFViewProdutosList.AtualizarTabelaElasticSearch(const pPage: Integer);
var
  lPageSize: Integer;
begin
  lPageSize := StrToIntDef(cbPageSizeElasticSearch.Text, 10);
  TClientTablePagination.Apply('tblProdutosElasticSearch',
    'lblProdutosElasticSearchPaginacao',
    'wlcProdutosElasticSearchPaginacao', lPageSize, pPage, False);

  TClientTablePagination.UpdateHeaderVisualState(tblProdutosElasticSearch,
    FSortElasticCampo, FSortElasticDesc);
end;

procedure TFViewProdutosList.AtualizarTabelaAssociar(const pPage: Integer);
begin
  TClientTablePagination.ApplyFromControls('tblProdutosAssociar',
    'paginationInfoProdutosAssociar',
    'listPaginationProdutosAssociar', 'cbPageSizeSelecionados',
    'edtPesquisarSelecionados', 10, pPage, False);

  TClientTablePagination.UpdateHeaderVisualState(tblProdutosAssociar,
    FSortAssociarCampo, FSortAssociarDesc);
end;

procedure TFViewProdutosList.AtualizarPreviewImagem(const pImagemSrc: string);
var
  lImgProduto, lBtnRemoverImagemPreview: TJSHTMLElement;
  lImagemSrc: string;
  lPossuiImagem: Boolean;
begin
  lImagemSrc := Trim(pImagemSrc);
  if lImagemSrc.IsEmpty or SameText(lImagemSrc, 'null') or SameText(lImagemSrc, 'undefined') then
    lImagemSrc := 'assets/img/produto_sem_imagem.webp';

  lImgProduto := TJSHTMLElement(Document.getElementById('imgProduto'));
  if Assigned(lImgProduto) then
    lImgProduto.setAttribute('src', lImagemSrc);

  lPossuiImagem := not SameText(lImagemSrc, 'assets/img/produto_sem_imagem.webp');
  lBtnRemoverImagemPreview := TJSHTMLElement(Document.getElementById('btnRemoverImagemPreview'));

  if Assigned(lBtnRemoverImagemPreview) then
  begin
    if lPossuiImagem then
      lBtnRemoverImagemPreview.style.setProperty('display', 'block')
    else
      lBtnRemoverImagemPreview.style.setProperty('display', 'none');
  end;
end;

procedure TFViewProdutosList.LimparCdsProdutosAprovacao(pAtualizarDados: Boolean);
begin
  cdsProdutosAssociar.Close;
  cdsProdutosAssociar.Open;

  if pAtualizarDados then
  begin
    FGridPlugin.Load;
    SetQuantidadeSelecionados;
  end;
end;

procedure TFViewProdutosList.LimparSelecaoSeletorImagens;
begin
  asm
    var lContainer = document.getElementById('seletorImagens');
    if (!lContainer) {
      return;
    }

    var lImagens = lContainer.querySelectorAll('img[data-img-src]');
    lImagens.forEach(function(lImg) {
      if (lImg.parentElement) {
        lImg.parentElement.style.border = '2px solid transparent';
        lImg.parentElement.style.boxShadow = 'none';
      }
    });
  end;
end;

procedure TFViewProdutosList.btnSalvarAlteracoesClick(Sender: TObject);
var
  lImagemOriginal,
  lNovaImagem : string;
  lAtualizouImagem : Boolean;
  lArray : TJSArray;
begin
  if cdsProdutosAssociar.RecordCount = 0 then
  begin
    TUtils.ChamarMensagemDialog(TTipoDialogo.INFORMACAO, 'Nenhum produto adicionado a lista!');
    Exit;
  end;

  if Await(TUtils.ChamarMensagemDialog(TTipoDialogo.CONFIRMACAO,
    'Tem certeza que deseja associar os produtos selecionados?')) then
  begin
    TUtils.ChamarDivLoading;

    lArray := TJSArray.New;

    cdsProdutosAssociar.DisableControls;
    cdsProdutosAssociar.First;
    try
      while not cdsProdutosAssociar.Eof do
      begin
        lImagemOriginal := cdsProdutosAssociar.FieldByName('imagem_original').AsString;

        if lImagemOriginal.ToUpper = 'NULL' then
          lImagemOriginal := EmptyStr;

        lNovaImagem := cdsProdutosAssociar.FieldByName('imagem').AsString;

        if lNovaImagem.ToUpper = 'NULL' then
          lNovaImagem := EmptyStr;

        lAtualizouImagem := lNovaImagem <> lImagemOriginal;

        if lAtualizouImagem or cdsProdutosAssociar.FieldByName('atualizou_status').AsBoolean then
          SetProdutoArray(lAtualizouImagem, lArray);

        cdsProdutosAssociar.Next;
      end;
    finally
      cdsProdutosAssociar.EnableControls;
    end;

    if lArray.Length = 0 then
      TUtils.ChamarMensagemDialog(TTipoDialogo.INFORMACAO, 'Nenhuma alteração foi feita em nenhum produto!')
    else
      XDataWebAssociarProdutos.RawInvoke('IService.AssociarProdutosAliado', [lArray]);
  end;
end;

procedure TFViewProdutosList.btnSalvarImagemClick(Sender: TObject);
begin
  if cdsProdutosAssociar.Locate('id', StrToIntDef(edtCodigoProduto.Text, 0), []) then
  begin
    if FImagemSelecionada <> cdsProdutosAssociar.FieldByName('imagem').AsString then
    begin
      cdsProdutosAssociar.Edit;
      cdsProdutosAssociar.FieldByName('imagem').AsString := FImagemSelecionada;

      if cdsProdutosAssociar.FieldByName('status').AsString = '1' then
        cdsProdutosAssociar.FieldByName('status').AsString := '2';

      cdsProdutosAssociar.Post;
    end;
  end;

  TUtils.CloseModal('modal_buscar_imagem');
end;

procedure TFViewProdutosList.btnSelecionadosTabClick(Sender: TObject);
var
  lJson: TJSObject;
  lArray: TJSArray;
begin
  TUtils.ChamarDivLoading('Carregando sugestão de associação!');
  cdsProdutosAssociar.DisableControls;
  cdsProdutosAssociar.First;
  lArray := TJSArray.new;

  try
    while not cdsProdutosAssociar.Eof do
    begin
      if not cdsProdutosAssociar.FieldByName('sugestao_carregada').AsBoolean then
      begin
        lJson := TJSObject.New;
        lJson['nome'] := cdsProdutosAssociar.FieldByName('nome').AsString;
        lJson['codigo_barras'] := cdsProdutosAssociar.FieldByName('codigo_barras').AsString;
        lJson['codigo_interno'] := cdsProdutosAssociar.FieldByName('codigo_interno').AsInteger;
        lJson['produto_id'] := cdsProdutosAssociar.FieldByName('id').AsInteger;
        lArray.push(lJson);
      end;

      cdsProdutosAssociar.Next;
    end;
  finally
    cdsProdutosAssociar.EnableControls;
  end;

  if lArray.Length = 0 then
  begin
    TUtils.OcultarDivLoading;
    AbrirModalAssociacao;
  end
  else
    XDataWebSugestaoProdutos.RawInvoke('IService.GetSugestaoAssociacaoProdutos', [lArray]);
end;

procedure TFViewProdutosList.cbbProdutoPrecoPadraoChange(Sender: TObject);
begin
  Filtrar;
end;

procedure TFViewProdutosList.cbbProdutoStatusChange(Sender: TObject);
begin
  Filtrar;
end;

procedure TFViewProdutosList.cbbStatusAssociacaoChange(Sender: TObject);
begin
  Filtrar;
end;

procedure TFViewProdutosList.cbPageSizeChange(Sender: TObject);
begin
  FGridPlugin.SetPageSize(StrToInt(cbPageSize.Text), True);
end;

procedure TFViewProdutosList.cbPageSizeSelecionadosChange(Sender: TObject);
begin
  AtualizarTabelaAssociar(1);
end;

procedure TFViewProdutosList.cbPageSizeElasticSearchChange(Sender: TObject);
begin
  AtualizarTabelaElasticSearch(1);
end;

procedure TFViewProdutosList.cbxProdutosDesativadosClick(Sender: TObject);
begin
  Filtrar;
end;

procedure TFViewProdutosList.cbxProdutosExcluidosClick(Sender: TObject);
begin
  Filtrar;
end;

class function TFViewProdutosList.CreateForm(AElementID: string; AShowEditProc: TEditProc): TForm;

  procedure AfterCreate(AForm: TObject);
  begin
    TFViewProdutosList(AForm).FEditProc := AShowEditProc;
  end;

begin
  Application.CreateForm(TFViewProdutosList, AElementID, Result, @AfterCreate);
end;

procedure TFViewProdutosList.edSearchKeyDown(Sender: TObject; var Key: Word; Shift: TShiftState);
begin
  tmrConsulta.Enabled := False;

  if Key = 13 then
    FGridPlugin.SetFilterText(edSearch.Text, True);
end;

procedure TFViewProdutosList.edSearchKeyUp(Sender: TObject; var Key: Word; Shift: TShiftState);
begin
  tmrConsulta.Interval := FTimerConsulta;
  tmrConsulta.Enabled := True;
end;

procedure TFViewProdutosList.edtPesquisarSelecionadosKeyUp(Sender: TObject;
  var Key: Word; Shift: TShiftState);
begin
  AtualizarTabelaAssociar(1);
end;

procedure TFViewProdutosList.ExibirMensagemInformacao(const pMensagem: string);
begin
  TUtils.ChamarMensagemDialog(TTipoDialogo.INFORMACAO, pMensagem);
end;

procedure TFViewProdutosList.tblProdutosAssociarClickCell(Sender: TObject; ACol,
  ARow: Integer);
begin
  if ARow > 0 then
    Exit;

  TClientTablePagination.ToggleAndSortDataSet(tblProdutosAssociar,
    cdsProdutosAssociar, ACol, ARow, FSortAssociarCampo, FSortAssociarDesc);

  AtualizarTabelaAssociar(1);
end;

procedure TFViewProdutosList.Filtrar;
begin
  FGridPlugin.FDatasetPlugin.FFilterPadrao := Trim(GetFiltro);
  FGridPlugin.Load;
end;

function TFViewProdutosList.GerarCodigoBarrasNovoFsProduto(pCodigoInterno, pBancoId : Integer;
  pCodigoBarras : string) : string;
begin
  Result := pCodigoBarras;

  if THelperServer.CodigoBarrasGeradoPeloSistema(pCodigoBarras, pCodigoInterno.ToString) or
    (pCodigoBarras = pCodigoInterno.ToString) then
    Result := 'DB' + pBancoId.ToString + 'P' + pCodigoInterno.ToString;
end;

function TFViewProdutosList.GetFiltro: string;
var
  lFiltroDesativado,
  lAssociacaoStatus: string;
  lListaFiltro : TStringList;
begin
  Result := EmptyStr;
  lListaFiltro := TStringList.Create;
  try
    if THelperServer.FQueryProdutos <> '' then
      lListaFiltro.Add(THelperServer.FQueryProdutos);

    case cbbProdutoStatus.ItemIndex of
      0: lListaFiltro.Add('(status ne 2)');
      5 : Result := EmptyStr;
      else lListaFiltro.Add('(status eq ' + cbbProdutoStatus.ItemIndex.ToString + ')');
    end;

    if cbbProdutoPrecoPadrao.ItemIndex <> 0 then
      lListaFiltro.Add('(preco_padrao eq ' + cbbProdutoPrecoPadrao.ItemIndex.ToString + ')');

    if not cbxProdutosDesativados.Checked then
      lListaFiltro.Add('(desativado eq false)');

    if not cbxProdutosExcluidos.Checked then
      lListaFiltro.Add('(excluido eq false)');

    case cbbStatusAssociacao.ItemIndex of
      1 : lListaFiltro.Add('(associacao.status eq 1)');
      2 : lListaFiltro.Add('((associacao.status eq 1) and (associacao.fsprod.foto eq null))');
      3 : lListaFiltro.Add('(associacao.fsprod.id eq null)');
    end;

    if lListaFiltro.Count > 0 then
      Result := string.Join(' and ', lListaFiltro.ToStringArray);
  finally
    if Assigned(lListaFiltro) then
      FreeAndNil(lListaFiltro)
  end;
end;

function TFViewProdutosList.MarcarProduto(pCodigoProduto: Integer) : Boolean;
var
  lStatus,
  lImagem: string;
  lAtualizouImagem : Boolean;
begin
  lAtualizouImagem := False;
  Result := True;

  if pCodigoProduto <> 0 then
  begin
    if not ProdutosDataset.Locate('id', pCodigoProduto, []) then
      Exit;
  end
  else
  begin
    pCodigoProduto := ProdutosDataset.FieldByName('id').AsInteger;

    if not ProdutosDataset.FieldByName('db.associar_produtos').AsBoolean then
    begin
      Result := False;
      Exit;
    end;
  end;

  if not cdsProdutosAssociar.Locate('id', pCodigoProduto, []) then
  begin
    lStatus := ProdutosDataset.FieldByName('associacao.status').AsString;

    if lStatus.ToUpper = 'NULL' then
      lStatus := '0';

    cdsProdutosAssociar.Append;
    cdsProdutosAssociar.FieldByName('nome').AsString := ProdutosDataset.FieldByName('nome').AsString;
    cdsProdutosAssociar.FieldByName('codigo_barras').AsString := ProdutosDataset.FieldByName('codigo_barras').AsString;
    cdsProdutosAssociar.FieldByName('id').AsInteger := pCodigoProduto;
    cdsProdutosAssociar.FieldByName('codigo_interno').AsInteger := ProdutosDataset.FieldByName('codigo_interno').AsInteger;
    cdsProdutosAssociar.FieldByName('status').AsString := ProdutosDataset.FieldByName('associacao.status').AsString;
    cdsProdutosAssociar.FieldByName('nome_fs_prod').AsString := ProdutosDataset.FieldByName('associacao.fsprod.nome').AsString;
    cdsProdutosAssociar.FieldByName('codigo_barras_fs_prod').AsString := ProdutosDataset.FieldByName('associacao.fsprod.codigo_barras').AsString;
    cdsProdutosAssociar.FieldByName('atualizou_status').AsBoolean := False;
    cdsProdutosAssociar.FieldByName('status_original').AsString := ProdutosDataset.FieldByName('associacao.status').AsString;
    cdsProdutosAssociar.FieldByName('data_base_id').AsInteger := ProdutosDataset.FieldByName('data_base_id').AsInteger;

    case StrToInt(lStatus) of
      0: lImagem := EmptyStr;
      1: lImagem := ProdutosDataset.FieldByName('associacao.fsprod.imagem').AsString;
      2, 3:
      begin
        cdsProdutosAssociar.FieldByName('atualizou_status').AsBoolean := True;
        lImagem := ProdutosDataset.FieldByName('associacao.imagem_aprovacao').AsString;
        lAtualizouImagem := (lImagem.IsEmpty or (lImagem.ToUpper = 'NULL'));
      end;
    end;

    cdsProdutosAssociar.FieldByName('imagem').AsString := lImagem;

    if lAtualizouImagem then
      cdsProdutosAssociar.FieldByName('imagem_original').AsString := EmptyStr
    else
      cdsProdutosAssociar.FieldByName('imagem_original').AsString := lImagem;

    cdsProdutosAssociar.FieldByName('fs_prod_id').AsString := ProdutosDataset.FieldByName('associacao.fsprod.id').AsString;

    if lStatus = '0' then
      cdsProdutosAssociar.FieldByName('sugestao_carregada').AsBoolean := False
    else
      cdsProdutosAssociar.FieldByName('sugestao_carregada').AsBoolean := True;

    cdsProdutosAssociar.Post;
  end;
end;

procedure TFViewProdutosList.ProdutosDatasetAfterOpen(DataSet: TDataSet);
begin
  if FProdutosAssociacaoPromocoes then
  begin
    FProdutosAssociacaoPromocoes := False;
    btnMarcarDesmarcarTodos.Click;
  end;
end;

procedure TFViewProdutosList.tblProdutosAssociarGetCellChildren(Sender: TObject; ACol, ARow: Integer; AField: TField; AValue: string; AElement: TJSHTMLElementRecord);
var
  RecordCod: Integer;
  RecordNome,
  RecordCodigoBarras,
  RecordStatus,
  RecordFsProdCod,
  RecordCodigoBarrasGerado: string;

  procedure BuscarImagemButtonClick(Sender: TObject);
  var
    lSeletorImagens: TJSHTMLElement;
    lImagemAtual: string;
  begin
    edtCodigoProduto.Text := RecordCod.ToString;
    edtNomeProduto.Text := RecordNome;

    lImagemAtual := EmptyStr;
    if cdsProdutosAssociar.Locate('id', RecordCod, []) then
      lImagemAtual := Trim(cdsProdutosAssociar.FieldByName('imagem').AsString);

    if lImagemAtual.IsEmpty or SameText(lImagemAtual, 'null') or SameText(lImagemAtual, 'undefined') then
    begin
      lImagemAtual := 'assets/img/produto_sem_imagem.webp';
      FImagemSelecionada := EmptyStr;
    end
    else
      FImagemSelecionada := lImagemAtual;

    AtualizarPreviewImagem(lImagemAtual);

    lSeletorImagens := TJSHTMLElement(Document.getElementById('seletorImagens'));
    if Assigned(lSeletorImagens) then
      lSeletorImagens.innerHTML := EmptyStr;

    TUtils.OpenModal('modal_buscar_imagem');
  end;

  procedure BuscarProdutosButtonClick(Sender: TObject);
  begin
    FIdFsProdAtual := RecordFsProdCod;
    cdsProdutosElasticSearch.Close;
    cdsProdutosElasticSearch.Open;
    edtProdutosElasticSearch.Clear;
    edtCodigoProdutoAssociadoModal.Text := RecordCod.ToString;
    edtNomeProdutoAssociadoModal.Text := RecordNome;
    edtCodBarrasProdutoAssociadoModal.Text := RecordCodigoBarras;
    edtCodigoBarrasGerado.Text := RecordCodigoBarrasGerado;
    edtProdutosElasticSearch.Text := RecordNome;
    btnSolicitarCadastroProduto.Enabled := RecordStatus <> '3';
    cbbTipoPesquisa.ItemIndex := 0;
    btnPesquisarProdutosElasticSearch.Click;
    TUtils.OpenModal('modal_produtos_elastic_search');
  end;

var
  lImagem: TImageControl;
  lImagemBase64: string;
  Button: TButton;
begin
  if ARow = 0 then
    Exit;

  RecordCod := cdsProdutosAssociar.FieldByName('id').AsInteger;
  RecordNome := cdsProdutosAssociar.FieldByName('nome').AsString;
  RecordCodigoBarras := cdsProdutosAssociar.FieldByName('codigo_barras').AsString;
  RecordStatus := cdsProdutosAssociar.FieldByName('status').AsString;
  RecordFsProdCod := cdsProdutosAssociar.FieldByName('fs_prod_id').AsString;
  RecordCodigoBarrasGerado := RecordCodigoBarras;

  if Pos('DB', RecordCodigoBarras.ToUpper) > 0  then
    RecordCodigoBarrasGerado := RecordCodigoBarras
  else
  begin
    RecordCodigoBarrasGerado := GerarCodigoBarrasNovoFsProduto(cdsProdutosAssociar.FieldByName('codigo_interno').AsInteger,
      cdsProdutosAssociar.FieldByName('data_base_id').AsInteger, cdsProdutosAssociar.FieldByName('codigo_barras').AsString)
  end;

  if tblProdutosAssociar.Columns[ACol].Title = 'Imagem' then
  begin
    lImagemBase64 := cdsProdutosAssociar.FieldByName('imagem').AsString;

    lImagem := TImageControl.Create(nil);
    lImagem.ParentElement := AElement.element;
    lImagem.Width := 75;
    lImagem.Height := 75;
    lImagem.AutoSize := False;
    lImagem.ElementHandle.setAttribute('data-test', 'produtos-grid-associacao');

    if THelperServer.PossuiImagem(lImagemBase64) then
      lImagem.url := lImagemBase64
    else
      lImagem.url := 'assets/img/produto_sem_imagem.webp';

    if RecordStatus.ToUpper = 'NULL' then
      lImagem.Cursor := crDefault
    else
    begin
      lImagem.ElementHandle.setAttribute('data-bs-toggle', 'tooltip');
      lImagem.ElementHandle.setAttribute('title', 'Buscar Foto Produto');
      lImagem.OnClick := @BuscarImagemButtonClick;
      lImagem.Cursor := crHandPoint;
    end;
  end
  else if tblProdutosAssociar.Columns[ACol].Title = 'Ações' then
  begin
    Button := TButton.Create(nil);
    Button.Caption := '<i class="fa fa-search"></i>';
    Button.OnClick := @BuscarProdutosButtonClick;
    Button.ElementClassName := 'btn btn-link btn-primary btn-lg';
    Button.ParentElement := AElement.element;
    Button.WidthStyle := TSizeStyle.ssAuto;
    Button.HeightStyle := TSizeStyle.ssAuto;
    Button.ElementHandle.setAttribute('data-test', 'btn_buscar_produtos');
    Button.ElementHandle.style.setProperty('padding', '10px');
    Button.ElementHandle.setAttribute('data-bs-toggle', 'tooltip');
    Button.ElementHandle.setAttribute('title', 'Buscar Produtos Associar');

    Button := TButton.Create(nil);
    Button.Caption := '<i class="fas fa-camera"></i>';
    Button.ParentElement := AElement.element;
    Button.WidthStyle := TSizeStyle.ssAuto;
    Button.HeightStyle := TSizeStyle.ssAuto;
    Button.ElementHandle.setAttribute('data-test', 'btn_buscar_foto');
    Button.ElementHandle.style.setProperty('padding', '10px');

    if RecordStatus.ToUpper = 'NULL' then
    begin
      Button.ElementClassName := 'btn btn-link text-muted btn-lg';
      Button.ElementHandle.style.setProperty('cursor', 'not-allowed');
    end
    else
    begin
      Button.ElementHandle.setAttribute('data-bs-toggle', 'tooltip');
      Button.ElementHandle.setAttribute('title', 'Buscar Foto Produto');
      Button.OnClick := @BuscarImagemButtonClick;
      Button.ElementClassName := 'btn btn-link btn-warning btn-lg';
    end;
  end;
end;

procedure TFViewProdutosList.tblProdutosAssociarGetCellClass(Sender: TObject; ACol, ARow: Integer; AField: TField; AValue: string; var AClassName: string);
begin
  if cdsProdutosAssociar.Tag = 0 then
    Exit;

  if ARow = 0 then
    AClassName := 'text-center'
  else
  begin
    case IndexStr(tblProdutosAssociar.Columns[ACol].DataField, ['nome', 'codigo_barras', 'nome_fs_prod', 'codigo_barras_fs_prod']) of
      0, 1, 2, 3:
        AClassName := 'text-start';
    else
      AClassName := 'text-center';
    end;
  end;
end;

procedure TFViewProdutosList.tblProdutosElasticSearchGetCellChildren(Sender: TObject; ACol, ARow: Integer; AField: TField; AValue: string; AElement: TJSHTMLElementRecord);
var
  RecordCodigoBarras,
  RecordBase64,
  RecordImagem,
  RecordProdutoNome: string;
  RecordProdutoId: Integer;

  [Async]
  procedure AssociarButtonClick(Sender: TObject); async;
  begin
    if Await(TUtils.ChamarMensagemDialog(TTipoDialogo.CONFIRMACAO, 'Tem certeza que deseja ' + 'associar o produto <b>' + RecordProdutoNome + '</b> ao produto <b>' + edtNomeProdutoAssociadoModal.Text + '</b>?')) then
    begin
      if cdsProdutosAssociar.Locate('id', StrToInt(edtCodigoProdutoAssociadoModal.Text), []) then
      begin
        cdsProdutosAssociar.Edit;

        cdsProdutosAssociar.FieldByName('nome_fs_prod').AsString := RecordProdutoNome;
        cdsProdutosAssociar.FieldByName('codigo_barras_fs_prod').AsString := RecordCodigoBarras;
        cdsProdutosAssociar.FieldByName('imagem').AsString := RecordImagem;
        cdsProdutosAssociar.FieldByName('sugestao_carregada').AsBoolean := True;
        cdsProdutosAssociar.FieldByName('fs_prod_id').AsString := RecordProdutoId.ToString;
        cdsProdutosAssociar.FieldByName('status').AsString := '1';
        cdsProdutosAssociar.FieldByName('atualizou_status').AsBoolean := True;
        cdsProdutosAssociar.FieldByName('imagem_original').AsString := RecordImagem;
        cdsProdutosAssociar.Post;
      end;

      TUtils.CloseModal('modal_produtos_elastic_search');
    end;
  end;

var
  Button: TButton;
  lImagem: TImageControl;
  lDesabilitar : Boolean;
begin
  if ARow = 0 then
    Exit;

  if tblProdutosElasticSearch.Columns[ACol].Title = 'Associar' then
  begin
    lDesabilitar := False;
    
    RecordProdutoNome := cdsProdutosElasticSearch.FieldByName('nome').AsString;
    RecordProdutoId := cdsProdutosElasticSearch.FieldByName('id').AsInteger;
    RecordCodigoBarras := cdsProdutosElasticSearch.FieldByName('codigo_barras').AsString;
    RecordImagem := cdsProdutosElasticSearch.FieldByName('imagem').AsString;

    Button := TButton.Create(nil);
    Button.Caption := '<i class="fas fa-boxes"></i>';
    Button.ParentElement := AElement.element;
    Button.WidthStyle := TSizeStyle.ssAuto;
    Button.HeightStyle := TSizeStyle.ssAuto;
    Button.ElementHandle.setAttribute('data-test', 'btn_associar_produto_modal');

    if not(FIdFsProdAtual.IsEmpty or (FIdFsProdAtual.ToUpper = 'NULL')) then
      lDesabilitar := StrToInt(FIdFsProdAtual) = RecordProdutoId;

    if lDesabilitar then
    begin
      Button.ElementClassName := 'btn btn-link text-muted btn-lg';
      Button.ElementHandle.style.setProperty('cursor', 'not-allowed');
    end
    else
    begin
      Button.OnClick := @AssociarButtonClick;
      Button.ElementClassName := 'btn btn-link btn-primary btn-lg';
      Button.ElementHandle.setAttribute('data-bs-toggle', 'tooltip');
      Button.ElementHandle.setAttribute('title', 'Associar produto');  
    end;
  end
  else if tblProdutosElasticSearch.Columns[ACol].Title = 'Imagem' then
  begin
    RecordBase64 := cdsProdutosElasticSearch.FieldByName('imagem').AsString;

    lImagem := TImageControl.Create(nil);
    lImagem.ParentElement := AElement.element;
    lImagem.Width := 50;
    lImagem.Height := 50;
    lImagem.AutoSize := False;

    if THelperServer.PossuiImagem(RecordBase64) then
      lImagem.url := RecordBase64
    else
      lImagem.url := 'assets/img/produto_sem_imagem.webp';
  end;
end;

procedure TFViewProdutosList.tblProdutosElasticSearchClickCell(Sender: TObject;
  ACol, ARow: Integer);
begin
  if ARow > 0 then
    Exit;

  TClientTablePagination.ToggleAndSortDataSet(tblProdutosElasticSearch,
    cdsProdutosElasticSearch, ACol, ARow, FSortElasticCampo, FSortElasticDesc);

  AtualizarTabelaElasticSearch(1);
end;

procedure TFViewProdutosList.tblProdutosElasticSearchGetCellClass(Sender: TObject; ACol, ARow: Integer; AField: TField; AValue: string; var AClassName: string);
begin
  {if ARow = 0 then
    AClassName := 'text-center'
  else
  begin
    case IndexStr(tblProdutosElasticSearch.Columns[ACol].DataField, ['nome', 'codigo_barras']) of
      0, 1: AClassName := 'text-start';
    else
      AClassName := 'text-center';
    end;
  end;  }
end;

procedure TFViewProdutosList.tmrConsultaTimer(Sender: TObject);
begin
  FGridPlugin.SetFilterText(edSearch.Text, True);

  tmrConsulta.Enabled := False;
  tmrConsulta.Interval := FTimerConsulta;
end;

procedure TFViewProdutosList.VerificarBotaoMarcarDesmarcarTodos;
var
  lMarcar : Boolean;
begin
  lMarcar := False;

  ProdutosDataset.DisableControls;
  ProdutosDataset.First;
  try
    while not ProdutosDataset.Eof do
    begin
      if not ProdutosDataset.FieldByName('selecionado').AsBoolean then
      begin
        lMarcar := True;
        Break;
      end;

      ProdutosDataset.Next;
    end;

    if lMarcar then
    begin
      AtualizarCaptionMarcarDesmarcarTodos(True);
      btnMarcarDesmarcarTodos.Tag := 0;
    end
    else
    begin
      AtualizarCaptionMarcarDesmarcarTodos(False);
      btnMarcarDesmarcarTodos.Tag := 1;
    end;

  finally
    ProdutosDataset.EnableControls;
  end;
end;

function TFViewProdutosList.VerificarQuantidadeMaximaSelecionada: Boolean;
begin
  Result := cdsProdutosAssociar.RecordCount = 50;

  if Result then
    TUtils.ChamarMensagemDialog(TTipoDialogo.INFORMACAO, 'Somente 50 produtos podem ser selecionados por vez!');
end;

procedure TFViewProdutosList.AbrirModalAssociacao;
begin
  TUtils.OcultarDivLoading;
end;

procedure TFViewProdutosList.btnSolicitarCadastroProdutoClick(Sender: TObject);
var
  lJson : TJSObject;
  lCodigoBarras : string;
begin
  TUtils.ChamarDivLoading;
  lJson := TJSObject.New;
  lJson['codigo_barras'] := edtCodigoBarrasGerado.Text;

  XDataWebListaElasticSearchCodBarras.RawInvoke('IService.GetProdutosElasticSearchFrontEnd', [lJson]);
end;

procedure TFViewProdutosList.WebDBTableControl1GetCellChildren(Sender: TObject; ACol, ARow: Integer; AField: TField; AValue: string; AElement: TJSHTMLElementRecord);
var
  RecordId: JSValue;
  RecordBase64: string;
  RecordCod: Integer;
  lBancoAssociacao : Boolean;

  procedure CheckBoxClick(Sender: TObject);
  var
    lCheckBoxSelecionado: TCheckBox;
    lMarcado: Boolean;
  begin
    TUtils.ChamarDivLoading;
    lCheckBoxSelecionado := TCheckBox(Sender);
    lMarcado := not cdsProdutosAssociar.Locate('id', RecordCod, []);

    if lMarcado then
    begin
      if VerificarQuantidadeMaximaSelecionada then
        Exit;

      MarcarProduto(RecordCod);
    end
    else
    begin
      if cdsProdutosAssociar.Locate('id', RecordCod, []) then
        cdsProdutosAssociar.Delete;
    end;

    lCheckBoxSelecionado.Checked := lMarcado;

    if ProdutosDataset.Locate('id', RecordCod, []) then
    begin
      ProdutosDataset.Edit;
      ProdutosDataset.FieldByName('selecionado').AsBoolean := lMarcado;
      ProdutosDataset.Post;
    end;

    SetQuantidadeSelecionados;
    TUtils.OcultarDivLoading;
  end;

  procedure EditButtonClick(Sender: TObject);
  begin
    FEditProc(RecordId);
  end;

var
  Button: TButton;
  lImagem: TImageControl;
  lCheckBox: TCheckBox;
  lStatus: string;
begin
  if ARow = 0 then
    Exit;

  RecordCod := ProdutosDataset.FieldByName('id').AsInteger;
  lBancoAssociacao := ProdutosDataset.FieldByName('db.associar_produtos').AsBoolean;

  if WebDBTableControl1.Columns[ACol].Title = 'Selecionar' then
  begin
    lCheckBox := TCheckBox.Create(nil);
    lCheckBox.ParentElement := AElement.element;
    lCheckBox.WidthStyle := TSizeStyle.ssAuto;
    lCheckBox.HeightStyle := TSizeStyle.ssAuto;
    lCheckBox.OnClick := @CheckBoxClick;
    lCheckBox.Checked := cdsProdutosAssociar.Locate('id', RecordCod, []);
    lCheckBox.Enabled := lBancoAssociacao;
    lCheckBox.ElementHandle.setAttribute('data-test', 'cbx_selecionar_produto');

    if not lBancoAssociacao then
    begin
      lCheckBox.ElementHandle.setAttribute('data-bs-toggle', 'tooltip');
      lCheckBox.ElementHandle.setAttribute('title', 'Produto pertence a uma banco não associado!');
    end
  end
  else if WebDBTableControl1.Columns[ACol].Title = 'Ação' then
  begin
    RecordId := TCrudUtils.GetIdFromObject(ProdutosDataset.Connection.Model.DefaultSchema.FindEntityType(ProdutosDataset.EntitySetName), ProdutosDataset.CurrentData);

    Button := TButton.Create(nil);
    Button.Caption := '<i class="fas fa-eye"></i>';
    Button.OnClick := @EditButtonClick;
    Button.ElementClassName := 'btn btn-link btn-primary btn-lg';
    Button.ParentElement := AElement.element;
    Button.WidthStyle := TSizeStyle.ssAuto;
    Button.HeightStyle := TSizeStyle.ssAuto;
    Button.ElementHandle.setAttribute('data-test', 'btn_visualizar_produto');
    Button.ElementHandle.setAttribute('data-bs-toggle', 'tooltip');
    Button.ElementHandle.setAttribute('title', 'Visualizar produto');
  end
  else if WebDBTableControl1.Columns[ACol].Title = 'Imagem' then
  begin
    RecordBase64 := ProdutosDataset.FieldByName('associacao.fsprod.imagem').AsString;

    lImagem := TImageControl.Create(nil);
    lImagem.ParentElement := AElement.element;
    lImagem.Width := 75;
    lImagem.Height := 75;
    lImagem.AutoSize := False;

    if THelperServer.PossuiImagem(RecordBase64) then
      lImagem.url := RecordBase64
    else
      lImagem.url := 'assets/img/produto_sem_imagem.webp';
  end;
end;

procedure TFViewProdutosList.WebDBTableControl1GetCellClass(Sender: TObject; ACol, ARow: Integer; AField: TField; AValue: string; var AClassName: string);
begin
  if ARow = 0 then
    AClassName := 'text-center'
  else
  begin
    case IndexStr(WebDBTableControl1.Columns[ACol].DataField, ['nome', 'codigo_barras', 'preco_padrao', 'subgrupo.nome', 'subgrupo.grupo.nome', 'aliado.Nome_Fantasia', 'estoque', 'preco']) of
      0, 1, 2, 3, 4, 5: AClassName := 'text-left';
      6, 7:AClassName := 'text-end';
      else
      begin
        if WebDBTableControl1.Columns[ACol].Title.ToLower = 'imagem' then
          AClassName := 'zoom-imagem'
        else
          AClassName := 'text-center';
      end;
    end;
  end;
end;

procedure TFViewProdutosList.WebDBTableControl1GetCellData(Sender: TObject; ACol, ARow: Integer; AField: TField; var AValue: string);
begin
  if ARow > 0 then
  begin
    case IndexStr(WebDBTableControl1.Columns[ACol].DataField, ['status', 'preco_padrao', 'excluido', 'promocao', 'aliado.Nome_Fantasia', 'associacao.status']) of
      0:
        begin
          case StrToInt(AValue) of
            1:
              AValue := '<div class="rounded-pill" style="background-color: #198754;color:white; padding-right: 5px;padding-left: 5px;">Ativo</div>';
            2:
              AValue := '<div class="rounded-pill" style="background-color: #FF6347;color:white; padding-right: 5px;padding-left: 5px;">Inativo</div>';
            3:
              AValue := '<div class="rounded-pill" style="background-color: #0054C3;color:white; padding-right: 5px;padding-left: 5px;">Balança</div>';
            4:
              AValue := '<div class="rounded-pill" style="background-color: #ffad46;color:white; padding-right: 5px;padding-left: 5px;">Bloqueado</div>';
          else
            AValue := '<div class="rounded-pill text-center" style="background-color: #1C1C1C;color:white; padding-right: 5px;padding-left: 5px;">Outros</div>';
          end;
        end;
      1:
        AValue := TUtils.GetPrecoPadraoProduto(StrToInt(AValue)).ToUpper;
      2, 3:
        begin
          if AValue = 'True' then
            AValue := '<i class="fas fa-check text-success"><i>'
          else if AValue = 'False' then
            AValue := '<i class="fas fa-times text-danger"><i>';
        end;
      4:
        AValue := AValue.ToUpper;
      5:
        AValue := THelperServer.GetStatusAssociacaoProdutoRounded(AValue);
    end;
  end;
end;

procedure TFViewProdutosList.WebFormCreate(Sender: TObject);
begin
  FImagemSelecionada := EmptyStr;
  btnMarcarDesmarcarTodos.Tag := 0;
  AtualizarCaptionMarcarDesmarcarTodos(True);

  asm
  var lForm = this;
  var lBtnRemoverImagemPreview = document.getElementById('btnRemoverImagemPreview');
  var lImgProduto = document.getElementById('imgProduto');
  var lInputImagemComputador = document.getElementById('inputImagemComputador');

  if (lImgProduto && lInputImagemComputador) {
    lImgProduto.onclick = function(e) {
      e.preventDefault();
      lInputImagemComputador.click();
    };
  }

  if (lInputImagemComputador) {
    lInputImagemComputador.onchange = function(e) {
      var lFile = (e.target && e.target.files && e.target.files[0]) ? e.target.files[0] : null;
      if (!lFile) {
        return;
      }


      var tiposPermitidos = ['image/png', 'image/jpeg', 'image/webp'];
      var tamanhoMaximo = 1 * 1024 * 1024; // 1MB

      if (tiposPermitidos.indexOf(lFile.type) === -1) {
        lForm.ExibirMensagemInformacao('Formato de imagem inválido!<br> Formatos válidos: png | jpg | jpeg | webp');
        lInputImagemComputador.value = '';
        return;
      }

      if (lFile.size > tamanhoMaximo) {
        lForm.ExibirMensagemInformacao('Tamanho de imagem inválido!<br> Insira uma imagem de até 1MB.');
        lInputImagemComputador.value = '';
        return;
      }


      var lReader = new FileReader();
      lReader.onload = function(ev) {
        var lDataUrl = (ev && ev.target && ev.target.result) ? String(ev.target.result) : '';
        if (!lDataUrl) {
          return;
        }

        lForm.FImagemSelecionada = lDataUrl;
        lForm.LimparSelecaoSeletorImagens();

        if (lImgProduto) {
          lImgProduto.setAttribute('src', lDataUrl);
        }

        if (lBtnRemoverImagemPreview) {
          lBtnRemoverImagemPreview.style.display = 'block';
        }
      };

      lReader.readAsDataURL(lFile);
    };
  }

  if (lBtnRemoverImagemPreview) {
    lBtnRemoverImagemPreview.onclick = function(e) {
      e.preventDefault();
      e.stopPropagation();
      lForm.RemoverImagemProdutoAtual();
    };
  }
  end;

  cdsProdutosAssociar.Close;
  cdsProdutosAssociar.Open;

  cdsProdutosAssociar.Tag := 1;
  FSortAssociarCampo := EmptyStr;
  FSortAssociarDesc := False;
  FSortElasticCampo := EmptyStr;
  FSortElasticDesc := False;
  FProdutosAssociacaoPromocoes := THelperServer.FQueryProdutos <> '';

  if FProdutosAssociacaoPromocoes then
  begin
    cbxProdutosExcluidos.Checked := True;
    cbxProdutosDesativados.Checked := True;
    cbbProdutoStatus.ItemIndex :=  5;
  end;

  FPersonalizacaoTabela := TPersonalizacao_Tabela.Create(Self.Name, WebDBTableControl1, cbPageSize);

  TUtils.SetValorDicionarioClasses('produtos', 'active');
  TUtils.SetValorDicionarioClasses('produtos_collapse', 'show');
  TUtils.SetValorDicionarioClasses('menu_produtos', 'active');

  TUtils.SetPaginaSelecionada;

  FGridPlugin := TGridPlugin.Create(WebDBTableControl1, ProdutosDataset, lcPaginator, lbPaginationInfo);

  FGridPlugin.FDatasetPlugin.FOrderByPadrao := 'nome';
  FGridPlugin.FDatasetPlugin.FFilterPadrao := Trim(GetFiltro);
  FGridPlugin.SetPageSize(StrToInt(cbPageSize.Text));
  FGridPlugin.SetFilterText(edSearch.Text);
  FGridPlugin.Load;

  AtualizarTabelaAssociar(1);
  AtualizarTabelaElasticSearch(1);

  SetQuantidadeSelecionados;

  btnSolicitarCadastroProduto.Caption := 'Cadastrar meu produto';
end;

procedure TFViewProdutosList.XDataWebAssociarProdutosError(
  Error: TXDataClientError);
begin
  TUtils.ChamarMensagemDialog(TTipoDialogo.ERROR, Error.ErrorMessage);
end;

procedure TFViewProdutosList.XDataWebAssociarProdutosLoad(
  Response: TXDataClientResponse);
begin
  if Response.RequestId = 'Remover Associacao' then
    TUtils.ChamarMensagemDialog(TTipoDialogo.SUCESSO, 'Associação removida com sucesso!')
  else
    TUtils.ChamarMensagemDialog(TTipoDialogo.SUCESSO, 'Produtos associados com sucesso!');

  if THelperServer.FQueryProdutos <> '' then
  begin
    THelperServer.FQueryProdutos := '';
    FGridPlugin.FDatasetPlugin.FFilterPadrao := Trim(GetFiltro);
  end;

  LimparCdsProdutosAprovacao(True);
  AtualizarCaptionMarcarDesmarcarTodos(True);
  btnMarcarDesmarcarTodos.Tag := 0;
  TUtils.SelecionarTab('#line-produtos-tab');
end;

procedure TFViewProdutosList.XDataWebListaElasticSearchCodBarrasError(Error: TXDataClientError);
begin
  TUtils.ChamarMensagemDialog(TTipoDialogo.ERROR, Error.ErrorMessage);
end;

procedure TFViewProdutosList.XDataWebListaElasticSearchCodBarrasLoad(Response: TXDataClientResponse);
begin
  if Assigned(Response.ResultAsArray) and (Response.ResultAsArray.length > 0) then
  begin
    cbbTipoPesquisa.ItemIndex := 1;
    edtProdutosElasticSearch.Text := edtCodBarrasProdutoAssociadoModal.Text;
    cdsProdutosElasticSearch.Close;
    cdsProdutosElasticSearch.Open;
    SetProdutosElasticSearch(Response.ResultAsArray);
    TUtils.ChamarMensagemDialog(TTipoDialogo.INFORMACAO, 'O produto com código de barras (' +
      edtCodigoBarrasGerado.Text + ') já existe na base de dados.' + sLineBreak + 'Selecione-o na tabela para fazer a associação!');
  end
  else
  begin
    if cdsProdutosAssociar.Locate('id', StrToInt(edtCodigoProdutoAssociadoModal.Text), []) then
    begin
      cdsProdutosAssociar.Edit;

      cdsProdutosAssociar.FieldByName('nome_fs_prod').AsString := EmptyStr;
      cdsProdutosAssociar.FieldByName('codigo_barras_fs_prod').AsString := EmptyStr;
      cdsProdutosAssociar.FieldByName('imagem').AsString := EmptyStr;
      cdsProdutosAssociar.FieldByName('sugestao_carregada').AsBoolean := True;
      cdsProdutosAssociar.FieldByName('fs_prod_id').AsString := EmptyStr;
      cdsProdutosAssociar.FieldByName('imagem_original').AsString := EmptyStr;
      cdsProdutosAssociar.FieldByName('status').AsString := '3';
      cdsProdutosAssociar.FieldByName('atualizou_status').AsBoolean := True;
      cdsProdutosAssociar.Post;
    end;

    TUtils.OcultarDivLoading;
    TUtils.CloseModal('modal_produtos_elastic_search');
  end;
end;

procedure TFViewProdutosList.XDataWebListaElasticSearchError(Error: TXDataClientError);
begin
  cdsProdutosElasticSearch.Close;
  cdsProdutosElasticSearch.Open;

  AtualizarTabelaElasticSearch(1);

  TUtils.OcultarDivLoading;
end;

procedure TFViewProdutosList.XDataWebListaElasticSearchLoad(Response: TXDataClientResponse);
begin
  if Assigned(Response.ResultAsArray) and (Response.ResultAsArray.length > 0) then
    SetProdutosElasticSearch(Response.ResultAsArray)
  else
  begin
    AtualizarTabelaElasticSearch(1);
    TUtils.OcultarDivLoading;
  end;
end;

procedure TFViewProdutosList.XDataWebSugestaoImagemError(Error: TXDataClientError);
begin
  TUtils.ChamarMensagemDialog(TTipoDialogo.ERROR, Error.ErrorMessage);
end;

procedure TFViewProdutosList.XDataWebSugestaoImagemLoad(Response: TXDataClientResponse);
var
  lSeletorImagens: TJSHTMLElement;
  lJsonObject: TJSObject;
  lArray, lArrayImagens: TJSArray;
  lIndice, lIndiceImagem, lQuantidadeImagens: Integer;
  lImagem, lHtmlImagens: string;
begin
  TUtils.OcultarDivLoading;

  lSeletorImagens := TJSHTMLElement(Document.getElementById('seletorImagens'));
  if not Assigned(lSeletorImagens) then
    Exit;

  lSeletorImagens.innerHTML := EmptyStr;
  lArray := Response.ResultAsArray;

  if (not Assigned(lArray)) or (lArray.Length = 0) then
  begin
    TUtils.ChamarMensagemDialog(TTipoDialogo.INFORMACAO, 'Nenhuma imagem foi encontrada!' + sLineBreak + 'Tente novamente usando outro nome.');
    Exit;
  end;

  lQuantidadeImagens := 0;
  lHtmlImagens := '<div class="card mt-3" style="border:1px solid #dee2e6;">' + '<div class="card-header bg-light"><strong>Imagens encontradas (__QTD__)</strong></div>' + '<div class="card-body"><div style="display:flex;flex-wrap:wrap;gap:12px;">';

  for lIndice := 0 to lArray.Length - 1 do
  begin
    lJsonObject := TJSObject(lArray[lIndice]);
    if not JS.isArray(lJsonObject['imagens']) then
      Continue;

    lArrayImagens := TJSArray(lJsonObject['imagens']);

    for lIndiceImagem := 0 to lArrayImagens.Length - 1 do
    begin
      lImagem := Trim(string(lArrayImagens[lIndiceImagem]));

      if lImagem.IsEmpty or SameText(lImagem, 'null') or SameText(lImagem, 'undefined') then
        Continue;

      Inc(lQuantidadeImagens);

      lHtmlImagens := lHtmlImagens + '<div class="card" style="width:112px;padding:5px;border:2px solid transparent;border-radius:8px;cursor:pointer;">' +
      '<img src="' + lImagem + '" data-img-src="' + lImagem + '"style="width:100px;height:100px;object-fit:cover;border-radius:6px;display:block;"' +
      ' onerror="this.parentElement.style.display=''none''" /></div>';
    end;
  end;

  lHtmlImagens := lHtmlImagens + '</div></div></div>';
  lHtmlImagens := StringReplace(lHtmlImagens, '__QTD__', IntToStr(lQuantidadeImagens), []);

  if Pos('<img', lHtmlImagens) > 0 then
  begin
    lSeletorImagens.innerHTML := lHtmlImagens;
    asm
      var lForm = this;
      var lContainer = document.getElementById('seletorImagens');
      if (lContainer) {
        var lImagens = lContainer.querySelectorAll('img[data-img-src]');
        lImagens.forEach(function(lImg) {
          lImg.onclick = function() {
            lImagens.forEach(function(lOutro) {
              if (lOutro.parentElement) {
                lOutro.parentElement.style.border = '2px solid transparent';
                lOutro.parentElement.style.boxShadow = 'none';
              }
            });

            if (lImg.parentElement) {
              lImg.parentElement.style.border = '2px solid #0d6efd';
              lImg.parentElement.style.boxShadow = '0 0 0 2px rgba(13,110,253,0.2)';
            }

            lForm.FImagemSelecionada = lImg.getAttribute('data-img-src') || '';

            var lImgProduto = document.getElementById('imgProduto');
            if (lImgProduto && lForm.FImagemSelecionada) {
              lImgProduto.setAttribute('src', lForm.FImagemSelecionada);
            }

            var lBtnRemoverImagemPreview = document.getElementById('btnRemoverImagemPreview');
            if (lBtnRemoverImagemPreview && lForm.FImagemSelecionada) {
              lBtnRemoverImagemPreview.style.display = 'block';
            }
          };
        });
      }
    end;
  end
  else
    TUtils.ChamarMensagemDialog(TTipoDialogo.INFORMACAO, 'Nenhuma imagem foi encontrada!' + sLineBreak + 'Tente novamente usando outro nome.');
end;

procedure TFViewProdutosList.XDataWebSugestaoProdutosError(Error: TXDataClientError);
begin
  AbrirModalAssociacao;
end;

procedure TFViewProdutosList.XDataWebSugestaoProdutosLoad(Response: TXDataClientResponse);
var
  lProdutoId, lIndice: Integer;
  lJsonArray: TJSArray;
  lJsonObject, lJsonAssociacaoSugerida: TJSObject;
  lImagem: JSValue;
  lImagemBase64: string;
  lAlterouImagem : Boolean;
begin
  lJsonArray := Response.ResultAsArray;

  for lIndice := 0 to lJsonArray.Length - 1 do
  begin
    lJsonObject := TJSObject(lJsonArray[lIndice]);
    lJsonAssociacaoSugerida := TJSObject(lJsonObject['associacao_sugerida']);
    lProdutoId := Integer(lJsonObject['produto_id']);
    lAlterouImagem := False;

    if (TJSJSON.stringify(lJsonAssociacaoSugerida) = '{}') or (UpperCase(TJSJSON.stringify(lJsonAssociacaoSugerida)) = 'NULL') then
      Continue;

    lImagem := lJsonAssociacaoSugerida['foto'];

    if Assigned(lImagem) and (UpperCase(string(lImagem)) <> 'NULL') then
      lImagemBase64 := string(lImagem)
    else
    begin
      lImagem := lJsonAssociacaoSugerida['imagem_sugerida'];

      if Assigned(lImagem) and (UpperCase(string(lImagem)) <> 'NULL') then
      begin
        lImagemBase64 := string(lImagem);
        lAlterouImagem := True;
      end;
    end;

    if cdsProdutosAssociar.Locate('id', lProdutoId, []) then
    begin
      cdsProdutosAssociar.Edit;

      cdsProdutosAssociar.FieldByName('nome_fs_prod').AsString := string(lJsonAssociacaoSugerida['nome']);
      cdsProdutosAssociar.FieldByName('codigo_barras_fs_prod').AsString := string(lJsonAssociacaoSugerida['codigo_barras']);
      cdsProdutosAssociar.FieldByName('sugestao_carregada').AsBoolean := True;
      cdsProdutosAssociar.FieldByName('fs_prod_id').AsString := string(lJsonAssociacaoSugerida['id']);

      if lAlterouImagem then
      begin
        cdsProdutosAssociar.FieldByName('status').AsString := '2';
        cdsProdutosAssociar.FieldByName('imagem_original').AsString := EmptyStr;
        cdsProdutosAssociar.FieldByName('imagem').AsString := lImagemBase64 ;
      end
      else
      begin
        cdsProdutosAssociar.FieldByName('status').AsString := '1';
        cdsProdutosAssociar.FieldByName('imagem_original').AsString := lImagemBase64;
        cdsProdutosAssociar.FieldByName('imagem').AsString := lImagemBase64 ;
      end;

      cdsProdutosAssociar.FieldByName('atualizou_status').AsBoolean := True;
      cdsProdutosAssociar.Post;
    end;
  end;
  TUtils.OcultarDivLoading;
  AbrirModalAssociacao;
end;

procedure TFViewProdutosList.LoadDFMValues;
begin
  inherited LoadDFMValues;

  lbPaginationInfo := TLabel.Create('view.produtos.list.pagination.info');
  WebDBTableControl1 := TDBTableControl.Create('view.produtos.list.table');
  cbPageSize := TComboBox.Create('view.produtos.list.cbPageSize');
  edSearch := TEdit.Create('view.produtos.list.search');
  lcPaginator := TListControl.Create('view.produtos.list.pagination');
  btnExportarExcel := TButton.Create('btnExportarExcel');
  cbbProdutoStatus := TComboBox.Create('cbbProdutoStatus');
  cbbProdutoPrecoPadrao := TComboBox.Create('cbbProdutoPrecoPadrao');
  cbxProdutosDesativados := TCheckBox.Create('cbxProdutosDesativados');
  cbxProdutosExcluidos := TCheckBox.Create('cbxProdutosExcluidos');
  tblProdutosAssociar := TDBTableControl.Create('tblProdutosAssociar');
  btnSelecionadosTab := TButton.Create('line-selecionados-tab');
  btnMarcarDesmarcarTodos := TButton.Create('btnMarcarDesmarcarTodos');
  btnPesquisarImagem := TButton.Create('btnPesquisarImagem');
  edtCodigoProduto := TEdit.Create('edtCodigoProduto');
  edtNomeProduto := TEdit.Create('edtNomeProduto');
  btnSalvarImagem := TButton.Create('btnSalvarImagem');
  btnRemoverAssociacao := TButton.Create('btnRemoverAssociacao');
  tblProdutosElasticSearch := TDBTableControl.Create('tblProdutosElasticSearch');
  edtCodigoProdutoAssociadoModal := TEdit.Create('edtCodigoProdutoAssociadoModal');
  edtNomeProdutoAssociadoModal := TEdit.Create('edtNomeProdutoAssociadoModal');
  edtCodBarrasProdutoAssociadoModal := TEdit.Create('edtCodBarrasProdutoAssociadoModal');
  edtProdutosElasticSearch := TEdit.Create('edtProdutosElasticSearch');
  btnPesquisarProdutosElasticSearch := TButton.Create('btnPesquisarProdutosElasticSearch');
  btnSolicitarCadastroProduto := TButton.Create('btnSolicitarCadastroProduto');
  cbbTipoPesquisa := TComboBox.Create('cbbTipoPesquisa');
  cbPageSizeElasticSearch := TComboBox.Create('cbPageSizeElasticSearch');
  cbPageSizeSelecionados := TComboBox.Create('cbPageSizeSelecionados');
  edtPesquisarSelecionados := TEdit.Create('edtPesquisarSelecionados');
  btnSalvarAlteracoes := TButton.Create('btnSalvarAlteracoes');
  cbbStatusAssociacao := TComboBox.Create('cbbStatusAssociacao');
  edtCodigoBarrasGerado := TEdit.Create(Self);
  ProdutosDataset := TXDataWebDataSet.Create(Self);
  ProdutosDatasetselecionado := TBooleanField.Create(Self);
  ProdutosDatasetcodigo_interno := TIntegerField.Create(Self);
  ProdutosDatasetassociacaofsprodimagem := TXDataWebDatasetField.Create(Self);
  ProdutosDatasetnome := TStringField.Create(Self);
  ProdutosDatasetcodigo_barras := TStringField.Create(Self);
  ProdutosDatasetpreco := TFloatField.Create(Self);
  ProdutosDatasetpromocao := TBooleanField.Create(Self);
  ProdutosDatasetpreco_padrao := TIntegerField.Create(Self);
  ProdutosDatasetpreco_custo := TFloatField.Create(Self);
  ProdutosDatasetpreco_venda := TFloatField.Create(Self);
  ProdutosDatasetpreco_promocional := TFloatField.Create(Self);
  ProdutosDatasetestoque := TFloatField.Create(Self);
  ProdutosDatasetunidadesigla := TXDataWebDatasetField.Create(Self);
  ProdutosDatasetstatus := TIntegerField.Create(Self);
  ProdutosDatasetsubgrupogruponome := TStringField.Create(Self);
  ProdutosDatasetsubgruponome := TStringField.Create(Self);
  ProdutosDatasetncmncm := TStringField.Create(Self);
  ProdutosDatasetcadastro := TDateTimeField.Create(Self);
  ProdutosDatasetaliadoNome_Fantasia := TStringField.Create(Self);
  ProdutosDatasetid := TIntegerField.Create(Self);
  ProdutosDatasetexcluido := TBooleanField.Create(Self);
  ProdutosDatasetinclusao := TDateTimeField.Create(Self);
  ProdutosDatasetalteracao := TDateTimeField.Create(Self);
  ProdutosDatasetexclusao := TDateTimeField.Create(Self);
  ProdutosDatasetassociacaostatus := TXDataWebDatasetField.Create(Self);
  ProdutosDatasetassociacaofsprodnome := TStringField.Create(Self);
  ProdutosDatasetassociacaofsprodcodigo_barras := TStringField.Create(Self);
  ProdutosDatasetassociacaoimagem_aprovacao := TStringField.Create(Self);
  ProdutosDatasetassociacaofsprodid := TIntegerField.Create(Self);
  ProdutosDatasetdbassociar_produtos := TBooleanField.Create(Self);
  ProdutosDatasetdata_base_id := TIntegerField.Create(Self);
  WebDataSource := TDataSource.Create(Self);
  tmrConsulta := TTimer.Create(Self);
  cdsProdutosAssociar := TXDataWebDataSet.Create(Self);
  cdsProdutosAssociarcodigo_interno := TStringField.Create(Self);
  cdsProdutosAssociarnome := TStringField.Create(Self);
  cdsProdutosAssociarcodigo_barras := TStringField.Create(Self);
  cdsProdutosAssociarid := TIntegerField.Create(Self);
  cdsProdutosAssociarstatus := TStringField.Create(Self);
  cdsProdutosAssociarimagem := TStringField.Create(Self);
  cdsProdutosAssociarnome_fs_prod := TStringField.Create(Self);
  cdsProdutosAssociarcodigo_barras_fs_prod := TStringField.Create(Self);
  cdsProdutosAssociarsugestao_carregada := TBooleanField.Create(Self);
  cdsProdutosAssociarfs_prod_id := TStringField.Create(Self);
  cdsProdutosAssociaratualizou_status := TBooleanField.Create(Self);
  cdsProdutosAssociarimagem_original := TStringField.Create(Self);
  cdsProdutosAssociarstatus_original := TStringField.Create(Self);
  cdsProdutosAssociardata_base_id := TIntegerField.Create(Self);
  dtsProdutosAssociar := TDataSource.Create(Self);
  XDataWebSugestaoProdutos := TXDataWebClient.Create(Self);
  XDataWebSugestaoImagem := TXDataWebClient.Create(Self);
  cdsProdutosElasticSearch := TXDataWebDataSet.Create(Self);
  IntegerField1 := TIntegerField.Create(Self);
  StringField2 := TStringField.Create(Self);
  StringField3 := TStringField.Create(Self);
  StringField5 := TStringField.Create(Self);
  dtsProdutosElasticSearch := TDataSource.Create(Self);
  XDataWebListaElasticSearch := TXDataWebClient.Create(Self);
  XDataWebListaElasticSearchCodBarras := TXDataWebClient.Create(Self);
  XDataWebAssociarProdutos := TXDataWebClient.Create(Self);

  lbPaginationInfo.BeforeLoadDFMValues;
  WebDBTableControl1.BeforeLoadDFMValues;
  cbPageSize.BeforeLoadDFMValues;
  edSearch.BeforeLoadDFMValues;
  lcPaginator.BeforeLoadDFMValues;
  btnExportarExcel.BeforeLoadDFMValues;
  cbbProdutoStatus.BeforeLoadDFMValues;
  cbbProdutoPrecoPadrao.BeforeLoadDFMValues;
  cbxProdutosDesativados.BeforeLoadDFMValues;
  cbxProdutosExcluidos.BeforeLoadDFMValues;
  tblProdutosAssociar.BeforeLoadDFMValues;
  btnSelecionadosTab.BeforeLoadDFMValues;
  btnMarcarDesmarcarTodos.BeforeLoadDFMValues;
  btnPesquisarImagem.BeforeLoadDFMValues;
  edtCodigoProduto.BeforeLoadDFMValues;
  edtNomeProduto.BeforeLoadDFMValues;
  btnSalvarImagem.BeforeLoadDFMValues;
  btnRemoverAssociacao.BeforeLoadDFMValues;
  tblProdutosElasticSearch.BeforeLoadDFMValues;
  edtCodigoProdutoAssociadoModal.BeforeLoadDFMValues;
  edtNomeProdutoAssociadoModal.BeforeLoadDFMValues;
  edtCodBarrasProdutoAssociadoModal.BeforeLoadDFMValues;
  edtProdutosElasticSearch.BeforeLoadDFMValues;
  btnPesquisarProdutosElasticSearch.BeforeLoadDFMValues;
  btnSolicitarCadastroProduto.BeforeLoadDFMValues;
  cbbTipoPesquisa.BeforeLoadDFMValues;
  cbPageSizeElasticSearch.BeforeLoadDFMValues;
  cbPageSizeSelecionados.BeforeLoadDFMValues;
  edtPesquisarSelecionados.BeforeLoadDFMValues;
  btnSalvarAlteracoes.BeforeLoadDFMValues;
  cbbStatusAssociacao.BeforeLoadDFMValues;
  edtCodigoBarrasGerado.BeforeLoadDFMValues;
  ProdutosDataset.BeforeLoadDFMValues;
  ProdutosDatasetselecionado.BeforeLoadDFMValues;
  ProdutosDatasetcodigo_interno.BeforeLoadDFMValues;
  ProdutosDatasetassociacaofsprodimagem.BeforeLoadDFMValues;
  ProdutosDatasetnome.BeforeLoadDFMValues;
  ProdutosDatasetcodigo_barras.BeforeLoadDFMValues;
  ProdutosDatasetpreco.BeforeLoadDFMValues;
  ProdutosDatasetpromocao.BeforeLoadDFMValues;
  ProdutosDatasetpreco_padrao.BeforeLoadDFMValues;
  ProdutosDatasetpreco_custo.BeforeLoadDFMValues;
  ProdutosDatasetpreco_venda.BeforeLoadDFMValues;
  ProdutosDatasetpreco_promocional.BeforeLoadDFMValues;
  ProdutosDatasetestoque.BeforeLoadDFMValues;
  ProdutosDatasetunidadesigla.BeforeLoadDFMValues;
  ProdutosDatasetstatus.BeforeLoadDFMValues;
  ProdutosDatasetsubgrupogruponome.BeforeLoadDFMValues;
  ProdutosDatasetsubgruponome.BeforeLoadDFMValues;
  ProdutosDatasetncmncm.BeforeLoadDFMValues;
  ProdutosDatasetcadastro.BeforeLoadDFMValues;
  ProdutosDatasetaliadoNome_Fantasia.BeforeLoadDFMValues;
  ProdutosDatasetid.BeforeLoadDFMValues;
  ProdutosDatasetexcluido.BeforeLoadDFMValues;
  ProdutosDatasetinclusao.BeforeLoadDFMValues;
  ProdutosDatasetalteracao.BeforeLoadDFMValues;
  ProdutosDatasetexclusao.BeforeLoadDFMValues;
  ProdutosDatasetassociacaostatus.BeforeLoadDFMValues;
  ProdutosDatasetassociacaofsprodnome.BeforeLoadDFMValues;
  ProdutosDatasetassociacaofsprodcodigo_barras.BeforeLoadDFMValues;
  ProdutosDatasetassociacaoimagem_aprovacao.BeforeLoadDFMValues;
  ProdutosDatasetassociacaofsprodid.BeforeLoadDFMValues;
  ProdutosDatasetdbassociar_produtos.BeforeLoadDFMValues;
  ProdutosDatasetdata_base_id.BeforeLoadDFMValues;
  WebDataSource.BeforeLoadDFMValues;
  tmrConsulta.BeforeLoadDFMValues;
  cdsProdutosAssociar.BeforeLoadDFMValues;
  cdsProdutosAssociarcodigo_interno.BeforeLoadDFMValues;
  cdsProdutosAssociarnome.BeforeLoadDFMValues;
  cdsProdutosAssociarcodigo_barras.BeforeLoadDFMValues;
  cdsProdutosAssociarid.BeforeLoadDFMValues;
  cdsProdutosAssociarstatus.BeforeLoadDFMValues;
  cdsProdutosAssociarimagem.BeforeLoadDFMValues;
  cdsProdutosAssociarnome_fs_prod.BeforeLoadDFMValues;
  cdsProdutosAssociarcodigo_barras_fs_prod.BeforeLoadDFMValues;
  cdsProdutosAssociarsugestao_carregada.BeforeLoadDFMValues;
  cdsProdutosAssociarfs_prod_id.BeforeLoadDFMValues;
  cdsProdutosAssociaratualizou_status.BeforeLoadDFMValues;
  cdsProdutosAssociarimagem_original.BeforeLoadDFMValues;
  cdsProdutosAssociarstatus_original.BeforeLoadDFMValues;
  cdsProdutosAssociardata_base_id.BeforeLoadDFMValues;
  dtsProdutosAssociar.BeforeLoadDFMValues;
  XDataWebSugestaoProdutos.BeforeLoadDFMValues;
  XDataWebSugestaoImagem.BeforeLoadDFMValues;
  cdsProdutosElasticSearch.BeforeLoadDFMValues;
  IntegerField1.BeforeLoadDFMValues;
  StringField2.BeforeLoadDFMValues;
  StringField3.BeforeLoadDFMValues;
  StringField5.BeforeLoadDFMValues;
  dtsProdutosElasticSearch.BeforeLoadDFMValues;
  XDataWebListaElasticSearch.BeforeLoadDFMValues;
  XDataWebListaElasticSearchCodBarras.BeforeLoadDFMValues;
  XDataWebAssociarProdutos.BeforeLoadDFMValues;
  try
    Name := 'FViewProdutosList';
    Width := 917;
    Height := 418;
    Font.Charset := DEFAULT_CHARSET;
    Font.Color := clWindowText;
    Font.Height := -11;
    Font.Name := 'Tahoma';
    Font.Style := [];
    ParentFont := False;
    SetEvent(Self, 'OnCreate', 'WebFormCreate');
    lbPaginationInfo.SetParentComponent(Self);
    lbPaginationInfo.Name := 'lbPaginationInfo';
    lbPaginationInfo.Left := 8;
    lbPaginationInfo.Top := 161;
    lbPaginationInfo.Width := 141;
    lbPaginationInfo.Height := 13;
    lbPaginationInfo.Caption := 'Showing 1 to 10 of 57 entries';
    lbPaginationInfo.HeightPercent := 100.000000000000000000;
    lbPaginationInfo.WidthPercent := 100.000000000000000000;
    WebDBTableControl1.SetParentComponent(Self);
    WebDBTableControl1.Name := 'WebDBTableControl1';
    WebDBTableControl1.Left := 8;
    WebDBTableControl1.Top := 38;
    WebDBTableControl1.Width := 296;
    WebDBTableControl1.Height := 106;
    WebDBTableControl1.ElementClassName := 'table-responsive';
    WebDBTableControl1.BorderColor := clSilver;
    WebDBTableControl1.ColHeader := False;
    WebDBTableControl1.ElementTableClassName := 'table table-striped table-bordered table-hover dataTable';
    SetEvent(WebDBTableControl1, Self, 'OnGetCellData', 'WebDBTableControl1GetCellData');
    SetEvent(WebDBTableControl1, Self, 'OnGetCellChildren', 'WebDBTableControl1GetCellChildren');
    SetEvent(WebDBTableControl1, Self, 'OnGetCellClass', 'WebDBTableControl1GetCellClass');
    WebDBTableControl1.Columns.Clear;
    with WebDBTableControl1.Columns.Add do
    begin
      Title := 'Selecionar';
    end;
    with WebDBTableControl1.Columns.Add do
    begin
      Title := 'A'#231#227'o';
    end;
    with WebDBTableControl1.Columns.Add do
    begin
      DataField := 'codigo_interno';
      Title := 'C'#243'd. Retaguarda';
    end;
    with WebDBTableControl1.Columns.Add do
    begin
      Title := 'Imagem';
    end;
    with WebDBTableControl1.Columns.Add do
    begin
      DataField := 'nome';
      Title := 'Nome';
    end;
    with WebDBTableControl1.Columns.Add do
    begin
      DataField := 'codigo_barras';
      Title := 'C'#243'd. Barras';
    end;
    with WebDBTableControl1.Columns.Add do
    begin
      DataField := 'preco';
      Title := 'Pre'#231'o';
    end;
    with WebDBTableControl1.Columns.Add do
    begin
      DataField := 'preco_padrao';
      Title := 'Pre'#231'o Padr'#227'o';
    end;
    with WebDBTableControl1.Columns.Add do
    begin
      DataField := 'promocao';
      Title := 'Promo'#231#227'o';
    end;
    with WebDBTableControl1.Columns.Add do
    begin
      DataField := 'estoque';
      Title := 'estoque';
    end;
    with WebDBTableControl1.Columns.Add do
    begin
      DataField := 'unidade.sigla';
      Title := 'Unidade';
    end;
    with WebDBTableControl1.Columns.Add do
    begin
      DataField := 'status';
      Title := 'Status';
    end;
    with WebDBTableControl1.Columns.Add do
    begin
      DataField := 'subgrupo.grupo.nome';
      Title := 'Grupo';
    end;
    with WebDBTableControl1.Columns.Add do
    begin
      DataField := 'subgrupo.nome';
      Title := 'SubGrupo';
    end;
    with WebDBTableControl1.Columns.Add do
    begin
      DataField := 'ncm.ncm';
      Title := 'Ncm';
    end;
    with WebDBTableControl1.Columns.Add do
    begin
      DataField := 'associacao.status';
      Title := 'Status Associa'#231#227'o';
    end;
    with WebDBTableControl1.Columns.Add do
    begin
      DataField := 'cadastro';
      Title := 'cadastro';
    end;
    with WebDBTableControl1.Columns.Add do
    begin
      DataField := 'aliado.Nome_Fantasia';
      Title := 'Aliado';
    end;
    with WebDBTableControl1.Columns.Add do
    begin
      DataField := 'id';
      Title := 'C'#243'd. Servidor';
    end;
    with WebDBTableControl1.Columns.Add do
    begin
      DataField := 'excluido';
      Title := 'Exclu'#237'do';
    end;
    with WebDBTableControl1.Columns.Add do
    begin
      DataField := 'inclusao';
      Title := 'Inclus'#227'o';
    end;
    with WebDBTableControl1.Columns.Add do
    begin
      DataField := 'alteracao';
      Title := 'Altera'#231#227'o';
    end;
    with WebDBTableControl1.Columns.Add do
    begin
      DataField := 'exclusao';
      Title := 'Exclus'#227'o';
    end;
    WebDBTableControl1.DataSource := WebDataSource;
    cbPageSize.SetParentComponent(Self);
    cbPageSize.Name := 'cbPageSize';
    cbPageSize.Left := 8;
    cbPageSize.Top := 11;
    cbPageSize.Width := 81;
    cbPageSize.Height := 21;
    cbPageSize.HeightPercent := 100.000000000000000000;
    cbPageSize.TabOrder := 2;
    cbPageSize.Text := '10';
    cbPageSize.WidthPercent := 100.000000000000000000;
    SetEvent(cbPageSize, Self, 'OnChange', 'cbPageSizeChange');
    cbPageSize.ItemIndex := 0;
    cbPageSize.Items.BeginUpdate;
    try
      cbPageSize.Items.Clear;
      cbPageSize.Items.Add('10');
      cbPageSize.Items.Add('25');
      cbPageSize.Items.Add('50');
      cbPageSize.Items.Add('100');
    finally
      cbPageSize.Items.EndUpdate;
    end;
    edSearch.SetParentComponent(Self);
    edSearch.Name := 'edSearch';
    edSearch.Left := 183;
    edSearch.Top := 11;
    edSearch.Width := 121;
    edSearch.Height := 21;
    edSearch.HeightPercent := 100.000000000000000000;
    edSearch.TabOrder := 3;
    edSearch.WidthPercent := 100.000000000000000000;
    SetEvent(edSearch, Self, 'OnKeyDown', 'edSearchKeyDown');
    SetEvent(edSearch, Self, 'OnKeyUp', 'edSearchKeyUp');
    lcPaginator.SetParentComponent(Self);
    lcPaginator.Name := 'lcPaginator';
    lcPaginator.Left := 188;
    lcPaginator.Top := 150;
    lcPaginator.Width := 113;
    lcPaginator.Height := 25;
    lcPaginator.HeightPercent := 100.000000000000000000;
    lcPaginator.WidthPercent := 100.000000000000000000;
    lcPaginator.DefaultItemClassName := 'page-item';
    lcPaginator.DefaultItemLinkClassName := 'page-link';
    lcPaginator.ElementListClassName := 'pagination';
    lcPaginator.Style := lsPagination;
    btnExportarExcel.SetParentComponent(Self);
    btnExportarExcel.Name := 'btnExportarExcel';
    btnExportarExcel.Left := 328;
    btnExportarExcel.Top := 9;
    btnExportarExcel.Width := 96;
    btnExportarExcel.Height := 25;
    btnExportarExcel.Caption := 'Exportar Excel';
    btnExportarExcel.ChildOrder := 11;
    btnExportarExcel.HeightPercent := 100.000000000000000000;
    btnExportarExcel.WidthPercent := 100.000000000000000000;
    SetEvent(btnExportarExcel, Self, 'OnClick', 'btnExportarExcelClick');
    cbbProdutoStatus.SetParentComponent(Self);
    cbbProdutoStatus.Name := 'cbbProdutoStatus';
    cbbProdutoStatus.Left := 328;
    cbbProdutoStatus.Top := 40;
    cbbProdutoStatus.Width := 96;
    cbbProdutoStatus.Height := 21;
    cbbProdutoStatus.HeightPercent := 100.000000000000000000;
    cbbProdutoStatus.Text := '<> Inativo';
    cbbProdutoStatus.WidthPercent := 100.000000000000000000;
    SetEvent(cbbProdutoStatus, Self, 'OnChange', 'cbbProdutoStatusChange');
    cbbProdutoStatus.ItemIndex := 0;
    cbbProdutoStatus.Items.BeginUpdate;
    try
      cbbProdutoStatus.Items.Clear;
      cbbProdutoStatus.Items.Add('<> Inativo');
      cbbProdutoStatus.Items.Add('Ativo');
      cbbProdutoStatus.Items.Add('Inativo');
      cbbProdutoStatus.Items.Add('Balan'#231'a');
      cbbProdutoStatus.Items.Add('Bloqueado');
      cbbProdutoStatus.Items.Add('Todos');
    finally
      cbbProdutoStatus.Items.EndUpdate;
    end;
    cbbProdutoPrecoPadrao.SetParentComponent(Self);
    cbbProdutoPrecoPadrao.Name := 'cbbProdutoPrecoPadrao';
    cbbProdutoPrecoPadrao.Left := 328;
    cbbProdutoPrecoPadrao.Top := 67;
    cbbProdutoPrecoPadrao.Width := 96;
    cbbProdutoPrecoPadrao.Height := 21;
    cbbProdutoPrecoPadrao.HeightPercent := 100.000000000000000000;
    cbbProdutoPrecoPadrao.Text := 'Todos';
    cbbProdutoPrecoPadrao.WidthPercent := 100.000000000000000000;
    SetEvent(cbbProdutoPrecoPadrao, Self, 'OnChange', 'cbbProdutoPrecoPadraoChange');
    cbbProdutoPrecoPadrao.ItemIndex := 0;
    cbbProdutoPrecoPadrao.Items.BeginUpdate;
    try
      cbbProdutoPrecoPadrao.Items.Clear;
      cbbProdutoPrecoPadrao.Items.Add('Todos');
      cbbProdutoPrecoPadrao.Items.Add('Custo');
      cbbProdutoPrecoPadrao.Items.Add('Venda');
      cbbProdutoPrecoPadrao.Items.Add('Promocional');
      cbbProdutoPrecoPadrao.Items.Add('Consignado');
    finally
      cbbProdutoPrecoPadrao.Items.EndUpdate;
    end;
    cbxProdutosDesativados.SetParentComponent(Self);
    cbxProdutosDesativados.Name := 'cbxProdutosDesativados';
    cbxProdutosDesativados.Left := 328;
    cbxProdutosDesativados.Top := 94;
    cbxProdutosDesativados.Width := 96;
    cbxProdutosDesativados.Height := 22;
    cbxProdutosDesativados.Caption := 'Exibir Desativados?';
    cbxProdutosDesativados.ChildOrder := 9;
    cbxProdutosDesativados.HeightPercent := 100.000000000000000000;
    cbxProdutosDesativados.WidthPercent := 100.000000000000000000;
    SetEvent(cbxProdutosDesativados, Self, 'OnClick', 'cbxProdutosDesativadosClick');
    cbxProdutosExcluidos.SetParentComponent(Self);
    cbxProdutosExcluidos.Name := 'cbxProdutosExcluidos';
    cbxProdutosExcluidos.Left := 328;
    cbxProdutosExcluidos.Top := 122;
    cbxProdutosExcluidos.Width := 96;
    cbxProdutosExcluidos.Height := 22;
    cbxProdutosExcluidos.Caption := 'Exibir Exclu'#237'dos?';
    cbxProdutosExcluidos.ChildOrder := 9;
    cbxProdutosExcluidos.HeightPercent := 100.000000000000000000;
    cbxProdutosExcluidos.WidthPercent := 100.000000000000000000;
    SetEvent(cbxProdutosExcluidos, Self, 'OnClick', 'cbxProdutosExcluidosClick');
    tblProdutosAssociar.SetParentComponent(Self);
    tblProdutosAssociar.Name := 'tblProdutosAssociar';
    tblProdutosAssociar.Left := 8;
    tblProdutosAssociar.Top := 198;
    tblProdutosAssociar.Width := 296;
    tblProdutosAssociar.Height := 106;
    tblProdutosAssociar.ElementClassName := 'table-responsive';
    tblProdutosAssociar.BorderColor := clSilver;
    tblProdutosAssociar.ChildOrder := 11;
    tblProdutosAssociar.ElementTableClassName := 'table table-striped table-bordered table-hover dataTable';
    SetEvent(tblProdutosAssociar, Self, 'OnClickCell', 'tblProdutosAssociarClickCell');
    SetEvent(tblProdutosAssociar, Self, 'OnGetCellChildren', 'tblProdutosAssociarGetCellChildren');
    SetEvent(tblProdutosAssociar, Self, 'OnGetCellClass', 'tblProdutosAssociarGetCellClass');
    tblProdutosAssociar.Columns.Clear;
    with tblProdutosAssociar.Columns.Add do
    begin
      Tag := 1;
      Title := 'A'#231#245'es';
      Width := 150;
    end;
    with tblProdutosAssociar.Columns.Add do
    begin
      DataField := 'codigo_interno';
      Tag := 1;
      Title := 'C'#243'd. Retaguarda';
    end;
    with tblProdutosAssociar.Columns.Add do
    begin
      DataField := 'nome';
      Title := 'Nome';
    end;
    with tblProdutosAssociar.Columns.Add do
    begin
      DataField := 'codigo_barras';
      Title := 'C'#243'd. Barras';
    end;
    with tblProdutosAssociar.Columns.Add do
    begin
      Tag := 1;
      Title := 'Imagem';
    end;
    with tblProdutosAssociar.Columns.Add do
    begin
      DataField := 'nome_fs_prod';
      Title := 'Nome Prod. Associado';
    end;
    with tblProdutosAssociar.Columns.Add do
    begin
      DataField := 'codigo_barras_fs_prod';
      Title := 'C'#243'd. Barras Prod. Associado';
    end;
    tblProdutosAssociar.DataSource := dtsProdutosAssociar;
    btnSelecionadosTab.SetParentComponent(Self);
    btnSelecionadosTab.Name := 'btnSelecionadosTab';
    btnSelecionadosTab.Left := 328;
    btnSelecionadosTab.Top := 229;
    btnSelecionadosTab.Width := 96;
    btnSelecionadosTab.Height := 25;
    btnSelecionadosTab.Caption := 'Selecionados';
    btnSelecionadosTab.ChildOrder := 11;
    btnSelecionadosTab.HeightPercent := 100.000000000000000000;
    btnSelecionadosTab.WidthPercent := 100.000000000000000000;
    SetEvent(btnSelecionadosTab, Self, 'OnClick', 'btnSelecionadosTabClick');
    btnMarcarDesmarcarTodos.SetParentComponent(Self);
    btnMarcarDesmarcarTodos.Name := 'btnMarcarDesmarcarTodos';
    btnMarcarDesmarcarTodos.Left := 328;
    btnMarcarDesmarcarTodos.Top := 260;
    btnMarcarDesmarcarTodos.Width := 96;
    btnMarcarDesmarcarTodos.Height := 25;
    btnMarcarDesmarcarTodos.Caption := 'Marcar Todos';
    btnMarcarDesmarcarTodos.ChildOrder := 11;
    btnMarcarDesmarcarTodos.HeightPercent := 100.000000000000000000;
    btnMarcarDesmarcarTodos.WidthPercent := 100.000000000000000000;
    SetEvent(btnMarcarDesmarcarTodos, Self, 'OnClick', 'btnMarcarDesmarcarTodosClick');
    btnPesquisarImagem.SetParentComponent(Self);
    btnPesquisarImagem.Name := 'btnPesquisarImagem';
    btnPesquisarImagem.Left := 328;
    btnPesquisarImagem.Top := 291;
    btnPesquisarImagem.Width := 96;
    btnPesquisarImagem.Height := 25;
    btnPesquisarImagem.Caption := 'Pesquisar';
    btnPesquisarImagem.ChildOrder := 11;
    btnPesquisarImagem.HeightPercent := 100.000000000000000000;
    btnPesquisarImagem.WidthPercent := 100.000000000000000000;
    SetEvent(btnPesquisarImagem, Self, 'OnClick', 'btnPesquisarImagemClick');
    edtCodigoProduto.SetParentComponent(Self);
    edtCodigoProduto.Name := 'edtCodigoProduto';
    edtCodigoProduto.Left := 8;
    edtCodigoProduto.Top := 310;
    edtCodigoProduto.Width := 81;
    edtCodigoProduto.Height := 22;
    edtCodigoProduto.ChildOrder := 15;
    edtCodigoProduto.Enabled := False;
    edtCodigoProduto.HeightPercent := 100.000000000000000000;
    edtCodigoProduto.WidthPercent := 100.000000000000000000;
    edtNomeProduto.SetParentComponent(Self);
    edtNomeProduto.Name := 'edtNomeProduto';
    edtNomeProduto.Left := 95;
    edtNomeProduto.Top := 310;
    edtNomeProduto.Width := 81;
    edtNomeProduto.Height := 22;
    edtNomeProduto.ChildOrder := 15;
    edtNomeProduto.HeightPercent := 100.000000000000000000;
    edtNomeProduto.WidthPercent := 100.000000000000000000;
    btnSalvarImagem.SetParentComponent(Self);
    btnSalvarImagem.Name := 'btnSalvarImagem';
    btnSalvarImagem.Left := 328;
    btnSalvarImagem.Top := 322;
    btnSalvarImagem.Width := 96;
    btnSalvarImagem.Height := 25;
    btnSalvarImagem.Caption := 'Salvar';
    btnSalvarImagem.ChildOrder := 11;
    btnSalvarImagem.HeightPercent := 100.000000000000000000;
    btnSalvarImagem.WidthPercent := 100.000000000000000000;
    SetEvent(btnSalvarImagem, Self, 'OnClick', 'btnSalvarImagemClick');
    btnRemoverAssociacao.SetParentComponent(Self);
    btnRemoverAssociacao.Name := 'btnRemoverAssociacao';
    btnRemoverAssociacao.Left := 328;
    btnRemoverAssociacao.Top := 198;
    btnRemoverAssociacao.Width := 96;
    btnRemoverAssociacao.Height := 25;
    btnRemoverAssociacao.Caption := 'Remover Associa'#231#227'o';
    btnRemoverAssociacao.ChildOrder := 11;
    btnRemoverAssociacao.HeightPercent := 100.000000000000000000;
    btnRemoverAssociacao.WidthPercent := 100.000000000000000000;
    SetEvent(btnRemoverAssociacao, Self, 'OnClick', 'btnRemoverAssociacaoClick');
    tblProdutosElasticSearch.SetParentComponent(Self);
    tblProdutosElasticSearch.Name := 'tblProdutosElasticSearch';
    tblProdutosElasticSearch.Left := 480;
    tblProdutosElasticSearch.Top := 9;
    tblProdutosElasticSearch.Width := 305;
    tblProdutosElasticSearch.Height := 106;
    tblProdutosElasticSearch.ElementClassName := 'table-responsive';
    tblProdutosElasticSearch.BorderColor := clSilver;
    tblProdutosElasticSearch.ChildOrder := 11;
    tblProdutosElasticSearch.ColHeader := False;
    tblProdutosElasticSearch.ElementTableClassName := 'table table-striped table-bordered table-hover dataTable';
    SetEvent(tblProdutosElasticSearch, Self, 'OnClickCell', 'tblProdutosElasticSearchClickCell');
    SetEvent(tblProdutosElasticSearch, Self, 'OnGetCellChildren', 'tblProdutosElasticSearchGetCellChildren');
    SetEvent(tblProdutosElasticSearch, Self, 'OnGetCellClass', 'tblProdutosElasticSearchGetCellClass');
    tblProdutosElasticSearch.Columns.Clear;
    with tblProdutosElasticSearch.Columns.Add do
    begin
      Tag := 1;
      Title := 'Associar';
    end;
    with tblProdutosElasticSearch.Columns.Add do
    begin
      Tag := 1;
      Title := 'Imagem';
    end;
    with tblProdutosElasticSearch.Columns.Add do
    begin
      DataField := 'nome';
      Title := 'Nome';
    end;
    with tblProdutosElasticSearch.Columns.Add do
    begin
      DataField := 'codigo_barras';
      Title := 'C'#243'd. Barras';
    end;
    tblProdutosElasticSearch.DataSource := dtsProdutosElasticSearch;
    edtCodigoProdutoAssociadoModal.SetParentComponent(Self);
    edtCodigoProdutoAssociadoModal.Name := 'edtCodigoProdutoAssociadoModal';
    edtCodigoProdutoAssociadoModal.Left := 480;
    edtCodigoProdutoAssociadoModal.Top := 121;
    edtCodigoProdutoAssociadoModal.Width := 121;
    edtCodigoProdutoAssociadoModal.Height := 22;
    edtCodigoProdutoAssociadoModal.ChildOrder := 20;
    edtCodigoProdutoAssociadoModal.Enabled := False;
    edtCodigoProdutoAssociadoModal.HeightPercent := 100.000000000000000000;
    edtCodigoProdutoAssociadoModal.WidthPercent := 100.000000000000000000;
    edtNomeProdutoAssociadoModal.SetParentComponent(Self);
    edtNomeProdutoAssociadoModal.Name := 'edtNomeProdutoAssociadoModal';
    edtNomeProdutoAssociadoModal.Left := 480;
    edtNomeProdutoAssociadoModal.Top := 149;
    edtNomeProdutoAssociadoModal.Width := 121;
    edtNomeProdutoAssociadoModal.Height := 22;
    edtNomeProdutoAssociadoModal.ChildOrder := 20;
    edtNomeProdutoAssociadoModal.Enabled := False;
    edtNomeProdutoAssociadoModal.HeightPercent := 100.000000000000000000;
    edtNomeProdutoAssociadoModal.WidthPercent := 100.000000000000000000;
    edtCodBarrasProdutoAssociadoModal.SetParentComponent(Self);
    edtCodBarrasProdutoAssociadoModal.Name := 'edtCodBarrasProdutoAssociadoModal';
    edtCodBarrasProdutoAssociadoModal.Left := 480;
    edtCodBarrasProdutoAssociadoModal.Top := 177;
    edtCodBarrasProdutoAssociadoModal.Width := 121;
    edtCodBarrasProdutoAssociadoModal.Height := 22;
    edtCodBarrasProdutoAssociadoModal.ChildOrder := 20;
    edtCodBarrasProdutoAssociadoModal.Enabled := False;
    edtCodBarrasProdutoAssociadoModal.HeightPercent := 100.000000000000000000;
    edtCodBarrasProdutoAssociadoModal.WidthPercent := 100.000000000000000000;
    edtProdutosElasticSearch.SetParentComponent(Self);
    edtProdutosElasticSearch.Name := 'edtProdutosElasticSearch';
    edtProdutosElasticSearch.Left := 607;
    edtProdutosElasticSearch.Top := 121;
    edtProdutosElasticSearch.Width := 121;
    edtProdutosElasticSearch.Height := 22;
    edtProdutosElasticSearch.ChildOrder := 20;
    edtProdutosElasticSearch.HeightPercent := 100.000000000000000000;
    edtProdutosElasticSearch.WidthPercent := 100.000000000000000000;
    btnPesquisarProdutosElasticSearch.SetParentComponent(Self);
    btnPesquisarProdutosElasticSearch.Name := 'btnPesquisarProdutosElasticSearch';
    btnPesquisarProdutosElasticSearch.Left := 807;
    btnPesquisarProdutosElasticSearch.Top := 9;
    btnPesquisarProdutosElasticSearch.Width := 96;
    btnPesquisarProdutosElasticSearch.Height := 25;
    btnPesquisarProdutosElasticSearch.Caption := 'Pesquisar';
    btnPesquisarProdutosElasticSearch.ChildOrder := 24;
    btnPesquisarProdutosElasticSearch.HeightPercent := 100.000000000000000000;
    btnPesquisarProdutosElasticSearch.WidthPercent := 100.000000000000000000;
    SetEvent(btnPesquisarProdutosElasticSearch, Self, 'OnClick', 'btnPesquisarProdutosElasticSearchClick');
    btnSolicitarCadastroProduto.SetParentComponent(Self);
    btnSolicitarCadastroProduto.Name := 'btnSolicitarCadastroProduto';
    btnSolicitarCadastroProduto.Left := 807;
    btnSolicitarCadastroProduto.Top := 40;
    btnSolicitarCadastroProduto.Width := 96;
    btnSolicitarCadastroProduto.Height := 25;
    btnSolicitarCadastroProduto.Caption := 'Solicitar cadastro meu produto';
    btnSolicitarCadastroProduto.ChildOrder := 24;
    btnSolicitarCadastroProduto.HeightPercent := 100.000000000000000000;
    btnSolicitarCadastroProduto.WidthPercent := 100.000000000000000000;
    SetEvent(btnSolicitarCadastroProduto, Self, 'OnClick', 'btnSolicitarCadastroProdutoClick');
    cbbTipoPesquisa.SetParentComponent(Self);
    cbbTipoPesquisa.Name := 'cbbTipoPesquisa';
    cbbTipoPesquisa.Left := 607;
    cbbTipoPesquisa.Top := 149;
    cbbTipoPesquisa.Width := 121;
    cbbTipoPesquisa.Height := 21;
    cbbTipoPesquisa.HeightPercent := 100.000000000000000000;
    cbbTipoPesquisa.Text := 'NOME';
    cbbTipoPesquisa.WidthPercent := 100.000000000000000000;
    cbbTipoPesquisa.ItemIndex := 0;
    cbbTipoPesquisa.Items.BeginUpdate;
    try
      cbbTipoPesquisa.Items.Clear;
      cbbTipoPesquisa.Items.Add('NOME');
      cbbTipoPesquisa.Items.Add('C'#211'D. BARRAS');
    finally
      cbbTipoPesquisa.Items.EndUpdate;
    end;
    cbPageSizeElasticSearch.SetParentComponent(Self);
    cbPageSizeElasticSearch.Name := 'cbPageSizeElasticSearch';
    cbPageSizeElasticSearch.Left := 736;
    cbPageSizeElasticSearch.Top := 149;
    cbPageSizeElasticSearch.Width := 67;
    cbPageSizeElasticSearch.Height := 21;
    cbPageSizeElasticSearch.HeightPercent := 100.000000000000000000;
    cbPageSizeElasticSearch.TabOrder := 2;
    cbPageSizeElasticSearch.Text := '10';
    cbPageSizeElasticSearch.WidthPercent := 100.000000000000000000;
    SetEvent(cbPageSizeElasticSearch, Self, 'OnChange', 'cbPageSizeElasticSearchChange');
    cbPageSizeElasticSearch.ItemIndex := 0;
    cbPageSizeElasticSearch.Items.BeginUpdate;
    try
      cbPageSizeElasticSearch.Items.Clear;
      cbPageSizeElasticSearch.Items.Add('10');
      cbPageSizeElasticSearch.Items.Add('25');
      cbPageSizeElasticSearch.Items.Add('50');
    finally
      cbPageSizeElasticSearch.Items.EndUpdate;
    end;
    cbPageSizeSelecionados.SetParentComponent(Self);
    cbPageSizeSelecionados.Name := 'cbPageSizeSelecionados';
    cbPageSizeSelecionados.Left := 182;
    cbPageSizeSelecionados.Top := 310;
    cbPageSizeSelecionados.Width := 81;
    cbPageSizeSelecionados.Height := 21;
    cbPageSizeSelecionados.HeightPercent := 100.000000000000000000;
    cbPageSizeSelecionados.TabOrder := 2;
    cbPageSizeSelecionados.Text := '10';
    cbPageSizeSelecionados.WidthPercent := 100.000000000000000000;
    SetEvent(cbPageSizeSelecionados, Self, 'OnChange', 'cbPageSizeSelecionadosChange');
    cbPageSizeSelecionados.ItemIndex := 0;
    cbPageSizeSelecionados.Items.BeginUpdate;
    try
      cbPageSizeSelecionados.Items.Clear;
      cbPageSizeSelecionados.Items.Add('10');
      cbPageSizeSelecionados.Items.Add('25');
      cbPageSizeSelecionados.Items.Add('50');
    finally
      cbPageSizeSelecionados.Items.EndUpdate;
    end;
    edtPesquisarSelecionados.SetParentComponent(Self);
    edtPesquisarSelecionados.Name := 'edtPesquisarSelecionados';
    edtPesquisarSelecionados.Left := 183;
    edtPesquisarSelecionados.Top := 337;
    edtPesquisarSelecionados.Width := 81;
    edtPesquisarSelecionados.Height := 22;
    edtPesquisarSelecionados.ChildOrder := 15;
    edtPesquisarSelecionados.HeightPercent := 100.000000000000000000;
    edtPesquisarSelecionados.WidthPercent := 100.000000000000000000;
    SetEvent(edtPesquisarSelecionados, Self, 'OnKeyUp', 'edtPesquisarSelecionadosKeyUp');
    btnSalvarAlteracoes.SetParentComponent(Self);
    btnSalvarAlteracoes.Name := 'btnSalvarAlteracoes';
    btnSalvarAlteracoes.Left := 807;
    btnSalvarAlteracoes.Top := 71;
    btnSalvarAlteracoes.Width := 96;
    btnSalvarAlteracoes.Height := 25;
    btnSalvarAlteracoes.Caption := 'Salvar Altera'#231#245'es';
    btnSalvarAlteracoes.ChildOrder := 24;
    btnSalvarAlteracoes.HeightPercent := 100.000000000000000000;
    btnSalvarAlteracoes.WidthPercent := 100.000000000000000000;
    SetEvent(btnSalvarAlteracoes, Self, 'OnClick', 'btnSalvarAlteracoesClick');
    cbbStatusAssociacao.SetParentComponent(Self);
    cbbStatusAssociacao.Name := 'cbbStatusAssociacao';
    cbbStatusAssociacao.Left := 328;
    cbbStatusAssociacao.Top := 150;
    cbbStatusAssociacao.Width := 96;
    cbbStatusAssociacao.Height := 21;
    cbbStatusAssociacao.HeightPercent := 100.000000000000000000;
    cbbStatusAssociacao.Text := 'Todos';
    cbbStatusAssociacao.WidthPercent := 100.000000000000000000;
    SetEvent(cbbStatusAssociacao, Self, 'OnChange', 'cbbStatusAssociacaoChange');
    cbbStatusAssociacao.ItemIndex := 0;
    cbbStatusAssociacao.Items.BeginUpdate;
    try
      cbbStatusAssociacao.Items.Clear;
      cbbStatusAssociacao.Items.Add('Todos');
      cbbStatusAssociacao.Items.Add('Associados');
      cbbStatusAssociacao.Items.Add('Associados (Sem Foto)');
      cbbStatusAssociacao.Items.Add('Desassociados');
    finally
      cbbStatusAssociacao.Items.EndUpdate;
    end;
    edtCodigoBarrasGerado.SetParentComponent(Self);
    edtCodigoBarrasGerado.Name := 'edtCodigoBarrasGerado';
    edtCodigoBarrasGerado.Left := 607;
    edtCodigoBarrasGerado.Top := 176;
    edtCodigoBarrasGerado.Width := 123;
    edtCodigoBarrasGerado.Height := 22;
    edtCodigoBarrasGerado.ChildOrder := 15;
    edtCodigoBarrasGerado.Enabled := False;
    edtCodigoBarrasGerado.HeightPercent := 100.000000000000000000;
    edtCodigoBarrasGerado.Visible := False;
    edtCodigoBarrasGerado.WidthPercent := 100.000000000000000000;
    ProdutosDataset.SetParentComponent(Self);
    ProdutosDataset.Name := 'ProdutosDataset';
    ProdutosDataset.AfterOpen := ProdutosDatasetAfterOpen;
    ProdutosDataset.EntitySetName := 'Produtos';
    ProdutosDataset.Connection := DMConnection.ApiConnection;
    ProdutosDataset.Left := 120;
    ProdutosDataset.Top := 64;
    ProdutosDatasetselecionado.SetParentComponent(ProdutosDataset);
    ProdutosDatasetselecionado.Name := 'ProdutosDatasetselecionado';
    ProdutosDatasetselecionado.Tag := 1;
    ProdutosDatasetselecionado.FieldName := 'selecionado';
    ProdutosDatasetcodigo_interno.SetParentComponent(ProdutosDataset);
    ProdutosDatasetcodigo_interno.Name := 'ProdutosDatasetcodigo_interno';
    ProdutosDatasetcodigo_interno.FieldName := 'codigo_interno';
    ProdutosDatasetcodigo_interno.Required := True;
    ProdutosDatasetassociacaofsprodimagem.SetParentComponent(ProdutosDataset);
    ProdutosDatasetassociacaofsprodimagem.Name := 'ProdutosDatasetassociacaofsprodimagem';
    ProdutosDatasetassociacaofsprodimagem.Tag := 1;
    ProdutosDatasetassociacaofsprodimagem.FieldName := 'associacao.fsprod.imagem';
    ProdutosDatasetnome.SetParentComponent(ProdutosDataset);
    ProdutosDatasetnome.Name := 'ProdutosDatasetnome';
    ProdutosDatasetnome.FieldName := 'nome';
    ProdutosDatasetnome.Required := True;
    ProdutosDatasetnome.Size := 255;
    ProdutosDatasetcodigo_barras.SetParentComponent(ProdutosDataset);
    ProdutosDatasetcodigo_barras.Name := 'ProdutosDatasetcodigo_barras';
    ProdutosDatasetcodigo_barras.FieldName := 'codigo_barras';
    ProdutosDatasetcodigo_barras.Size := 255;
    ProdutosDatasetpreco.SetParentComponent(ProdutosDataset);
    ProdutosDatasetpreco.Name := 'ProdutosDatasetpreco';
    ProdutosDatasetpreco.Tag := 3;
    ProdutosDatasetpreco.FieldName := 'preco';
    ProdutosDatasetpreco.DisplayFormat := '0.000';
    ProdutosDatasetpromocao.SetParentComponent(ProdutosDataset);
    ProdutosDatasetpromocao.Name := 'ProdutosDatasetpromocao';
    ProdutosDatasetpromocao.Tag := 3;
    ProdutosDatasetpromocao.FieldName := 'promocao';
    ProdutosDatasetpreco_padrao.SetParentComponent(ProdutosDataset);
    ProdutosDatasetpreco_padrao.Name := 'ProdutosDatasetpreco_padrao';
    ProdutosDatasetpreco_padrao.FieldName := 'preco_padrao';
    ProdutosDatasetpreco_padrao.Required := True;
    ProdutosDatasetpreco_custo.SetParentComponent(ProdutosDataset);
    ProdutosDatasetpreco_custo.Name := 'ProdutosDatasetpreco_custo';
    ProdutosDatasetpreco_custo.FieldName := 'preco_custo';
    ProdutosDatasetpreco_custo.Required := True;
    ProdutosDatasetpreco_custo.DisplayFormat := '0.000';
    ProdutosDatasetpreco_venda.SetParentComponent(ProdutosDataset);
    ProdutosDatasetpreco_venda.Name := 'ProdutosDatasetpreco_venda';
    ProdutosDatasetpreco_venda.FieldName := 'preco_venda';
    ProdutosDatasetpreco_venda.Required := True;
    ProdutosDatasetpreco_venda.DisplayFormat := '0.000';
    ProdutosDatasetpreco_promocional.SetParentComponent(ProdutosDataset);
    ProdutosDatasetpreco_promocional.Name := 'ProdutosDatasetpreco_promocional';
    ProdutosDatasetpreco_promocional.FieldName := 'preco_promocional';
    ProdutosDatasetpreco_promocional.DisplayFormat := '0.000';
    ProdutosDatasetestoque.SetParentComponent(ProdutosDataset);
    ProdutosDatasetestoque.Name := 'ProdutosDatasetestoque';
    ProdutosDatasetestoque.FieldName := 'estoque';
    ProdutosDatasetestoque.DisplayFormat := '0.000';
    ProdutosDatasetunidadesigla.SetParentComponent(ProdutosDataset);
    ProdutosDatasetunidadesigla.Name := 'ProdutosDatasetunidadesigla';
    ProdutosDatasetunidadesigla.FieldName := 'unidade.sigla';
    ProdutosDatasetstatus.SetParentComponent(ProdutosDataset);
    ProdutosDatasetstatus.Name := 'ProdutosDatasetstatus';
    ProdutosDatasetstatus.FieldName := 'status';
    ProdutosDatasetstatus.Required := True;
    ProdutosDatasetsubgrupogruponome.SetParentComponent(ProdutosDataset);
    ProdutosDatasetsubgrupogruponome.Name := 'ProdutosDatasetsubgrupogruponome';
    ProdutosDatasetsubgrupogruponome.FieldName := 'subgrupo.grupo.nome';
    ProdutosDatasetsubgruponome.SetParentComponent(ProdutosDataset);
    ProdutosDatasetsubgruponome.Name := 'ProdutosDatasetsubgruponome';
    ProdutosDatasetsubgruponome.FieldName := 'subgrupo.nome';
    ProdutosDatasetncmncm.SetParentComponent(ProdutosDataset);
    ProdutosDatasetncmncm.Name := 'ProdutosDatasetncmncm';
    ProdutosDatasetncmncm.FieldName := 'ncm.ncm';
    ProdutosDatasetcadastro.SetParentComponent(ProdutosDataset);
    ProdutosDatasetcadastro.Name := 'ProdutosDatasetcadastro';
    ProdutosDatasetcadastro.FieldName := 'cadastro';
    ProdutosDatasetcadastro.DisplayFormat := 'dd/mm/yyyy';
    ProdutosDatasetaliadoNome_Fantasia.SetParentComponent(ProdutosDataset);
    ProdutosDatasetaliadoNome_Fantasia.Name := 'ProdutosDatasetaliadoNome_Fantasia';
    ProdutosDatasetaliadoNome_Fantasia.FieldName := 'aliado.Nome_Fantasia';
    ProdutosDatasetid.SetParentComponent(ProdutosDataset);
    ProdutosDatasetid.Name := 'ProdutosDatasetid';
    ProdutosDatasetid.FieldName := 'id';
    ProdutosDatasetid.Required := True;
    ProdutosDatasetexcluido.SetParentComponent(ProdutosDataset);
    ProdutosDatasetexcluido.Name := 'ProdutosDatasetexcluido';
    ProdutosDatasetexcluido.FieldName := 'excluido';
    ProdutosDatasetinclusao.SetParentComponent(ProdutosDataset);
    ProdutosDatasetinclusao.Name := 'ProdutosDatasetinclusao';
    ProdutosDatasetinclusao.FieldName := 'inclusao';
    ProdutosDatasetinclusao.DisplayFormat := 'dd/mm/yyyy hh:nn:ss';
    ProdutosDatasetalteracao.SetParentComponent(ProdutosDataset);
    ProdutosDatasetalteracao.Name := 'ProdutosDatasetalteracao';
    ProdutosDatasetalteracao.FieldName := 'alteracao';
    ProdutosDatasetalteracao.DisplayFormat := 'dd/mm/yyyy hh:nn:ss';
    ProdutosDatasetexclusao.SetParentComponent(ProdutosDataset);
    ProdutosDatasetexclusao.Name := 'ProdutosDatasetexclusao';
    ProdutosDatasetexclusao.FieldName := 'exclusao';
    ProdutosDatasetexclusao.DisplayFormat := 'dd/mm/yyyy hh:nn:ss';
    ProdutosDatasetassociacaostatus.SetParentComponent(ProdutosDataset);
    ProdutosDatasetassociacaostatus.Name := 'ProdutosDatasetassociacaostatus';
    ProdutosDatasetassociacaostatus.Tag := 2;
    ProdutosDatasetassociacaostatus.FieldName := 'associacao.status';
    ProdutosDatasetassociacaofsprodnome.SetParentComponent(ProdutosDataset);
    ProdutosDatasetassociacaofsprodnome.Name := 'ProdutosDatasetassociacaofsprodnome';
    ProdutosDatasetassociacaofsprodnome.Tag := 1;
    ProdutosDatasetassociacaofsprodnome.FieldName := 'associacao.fsprod.nome';
    ProdutosDatasetassociacaofsprodcodigo_barras.SetParentComponent(ProdutosDataset);
    ProdutosDatasetassociacaofsprodcodigo_barras.Name := 'ProdutosDatasetassociacaofsprodcodigo_barras';
    ProdutosDatasetassociacaofsprodcodigo_barras.Tag := 1;
    ProdutosDatasetassociacaofsprodcodigo_barras.FieldName := 'associacao.fsprod.codigo_barras';
    ProdutosDatasetassociacaoimagem_aprovacao.SetParentComponent(ProdutosDataset);
    ProdutosDatasetassociacaoimagem_aprovacao.Name := 'ProdutosDatasetassociacaoimagem_aprovacao';
    ProdutosDatasetassociacaoimagem_aprovacao.Tag := 1;
    ProdutosDatasetassociacaoimagem_aprovacao.FieldName := 'associacao.imagem_aprovacao';
    ProdutosDatasetassociacaofsprodid.SetParentComponent(ProdutosDataset);
    ProdutosDatasetassociacaofsprodid.Name := 'ProdutosDatasetassociacaofsprodid';
    ProdutosDatasetassociacaofsprodid.FieldName := 'associacao.fsprod.id';
    ProdutosDatasetdbassociar_produtos.SetParentComponent(ProdutosDataset);
    ProdutosDatasetdbassociar_produtos.Name := 'ProdutosDatasetdbassociar_produtos';
    ProdutosDatasetdbassociar_produtos.FieldName := 'db.associar_produtos';
    ProdutosDatasetdata_base_id.SetParentComponent(ProdutosDataset);
    ProdutosDatasetdata_base_id.Name := 'ProdutosDatasetdata_base_id';
    ProdutosDatasetdata_base_id.Tag := 1;
    ProdutosDatasetdata_base_id.FieldName := 'data_base_id';
    ProdutosDatasetdata_base_id.Required := True;
    WebDataSource.SetParentComponent(Self);
    WebDataSource.Name := 'WebDataSource';
    WebDataSource.DataSet := ProdutosDataset;
    WebDataSource.Left := 200;
    WebDataSource.Top := 64;
    tmrConsulta.SetParentComponent(Self);
    tmrConsulta.Name := 'tmrConsulta';
    tmrConsulta.Enabled := False;
    SetEvent(tmrConsulta, Self, 'OnTimer', 'tmrConsultaTimer');
    tmrConsulta.Left := 64;
    tmrConsulta.Top := 64;
    cdsProdutosAssociar.SetParentComponent(Self);
    cdsProdutosAssociar.Name := 'cdsProdutosAssociar';
    cdsProdutosAssociar.Left := 160;
    cdsProdutosAssociar.Top := 232;
    cdsProdutosAssociarcodigo_interno.SetParentComponent(cdsProdutosAssociar);
    cdsProdutosAssociarcodigo_interno.Name := 'cdsProdutosAssociarcodigo_interno';
    cdsProdutosAssociarcodigo_interno.FieldName := 'codigo_interno';
    cdsProdutosAssociarnome.SetParentComponent(cdsProdutosAssociar);
    cdsProdutosAssociarnome.Name := 'cdsProdutosAssociarnome';
    cdsProdutosAssociarnome.FieldName := 'nome';
    cdsProdutosAssociarcodigo_barras.SetParentComponent(cdsProdutosAssociar);
    cdsProdutosAssociarcodigo_barras.Name := 'cdsProdutosAssociarcodigo_barras';
    cdsProdutosAssociarcodigo_barras.FieldName := 'codigo_barras';
    cdsProdutosAssociarid.SetParentComponent(cdsProdutosAssociar);
    cdsProdutosAssociarid.Name := 'cdsProdutosAssociarid';
    cdsProdutosAssociarid.FieldName := 'id';
    cdsProdutosAssociarstatus.SetParentComponent(cdsProdutosAssociar);
    cdsProdutosAssociarstatus.Name := 'cdsProdutosAssociarstatus';
    cdsProdutosAssociarstatus.FieldName := 'status';
    cdsProdutosAssociarimagem.SetParentComponent(cdsProdutosAssociar);
    cdsProdutosAssociarimagem.Name := 'cdsProdutosAssociarimagem';
    cdsProdutosAssociarimagem.FieldName := 'imagem';
    cdsProdutosAssociarnome_fs_prod.SetParentComponent(cdsProdutosAssociar);
    cdsProdutosAssociarnome_fs_prod.Name := 'cdsProdutosAssociarnome_fs_prod';
    cdsProdutosAssociarnome_fs_prod.FieldName := 'nome_fs_prod';
    cdsProdutosAssociarcodigo_barras_fs_prod.SetParentComponent(cdsProdutosAssociar);
    cdsProdutosAssociarcodigo_barras_fs_prod.Name := 'cdsProdutosAssociarcodigo_barras_fs_prod';
    cdsProdutosAssociarcodigo_barras_fs_prod.FieldName := 'codigo_barras_fs_prod';
    cdsProdutosAssociarsugestao_carregada.SetParentComponent(cdsProdutosAssociar);
    cdsProdutosAssociarsugestao_carregada.Name := 'cdsProdutosAssociarsugestao_carregada';
    cdsProdutosAssociarsugestao_carregada.FieldName := 'sugestao_carregada';
    cdsProdutosAssociarfs_prod_id.SetParentComponent(cdsProdutosAssociar);
    cdsProdutosAssociarfs_prod_id.Name := 'cdsProdutosAssociarfs_prod_id';
    cdsProdutosAssociarfs_prod_id.FieldName := 'fs_prod_id';
    cdsProdutosAssociaratualizou_status.SetParentComponent(cdsProdutosAssociar);
    cdsProdutosAssociaratualizou_status.Name := 'cdsProdutosAssociaratualizou_status';
    cdsProdutosAssociaratualizou_status.FieldName := 'atualizou_status';
    cdsProdutosAssociarimagem_original.SetParentComponent(cdsProdutosAssociar);
    cdsProdutosAssociarimagem_original.Name := 'cdsProdutosAssociarimagem_original';
    cdsProdutosAssociarimagem_original.FieldName := 'imagem_original';
    cdsProdutosAssociarstatus_original.SetParentComponent(cdsProdutosAssociar);
    cdsProdutosAssociarstatus_original.Name := 'cdsProdutosAssociarstatus_original';
    cdsProdutosAssociarstatus_original.FieldName := 'status_original';
    cdsProdutosAssociardata_base_id.SetParentComponent(cdsProdutosAssociar);
    cdsProdutosAssociardata_base_id.Name := 'cdsProdutosAssociardata_base_id';
    cdsProdutosAssociardata_base_id.FieldName := 'data_base_id';
    dtsProdutosAssociar.SetParentComponent(Self);
    dtsProdutosAssociar.Name := 'dtsProdutosAssociar';
    dtsProdutosAssociar.DataSet := cdsProdutosAssociar;
    dtsProdutosAssociar.Left := 80;
    dtsProdutosAssociar.Top := 232;
    XDataWebSugestaoProdutos.SetParentComponent(Self);
    XDataWebSugestaoProdutos.Name := 'XDataWebSugestaoProdutos';
    XDataWebSugestaoProdutos.Connection := DMConnection.ApiConnection;
    SetEvent(XDataWebSugestaoProdutos, Self, 'OnLoad', 'XDataWebSugestaoProdutosLoad');
    SetEvent(XDataWebSugestaoProdutos, Self, 'OnError', 'XDataWebSugestaoProdutosError');
    XDataWebSugestaoProdutos.Left := 32;
    XDataWebSugestaoProdutos.Top := 360;
    XDataWebSugestaoImagem.SetParentComponent(Self);
    XDataWebSugestaoImagem.Name := 'XDataWebSugestaoImagem';
    XDataWebSugestaoImagem.Connection := DMConnection.ApiConnection;
    SetEvent(XDataWebSugestaoImagem, Self, 'OnLoad', 'XDataWebSugestaoImagemLoad');
    SetEvent(XDataWebSugestaoImagem, Self, 'OnError', 'XDataWebSugestaoImagemError');
    XDataWebSugestaoImagem.Left := 160;
    XDataWebSugestaoImagem.Top := 360;
    cdsProdutosElasticSearch.SetParentComponent(Self);
    cdsProdutosElasticSearch.Name := 'cdsProdutosElasticSearch';
    cdsProdutosElasticSearch.Left := 640;
    cdsProdutosElasticSearch.Top := 43;
    IntegerField1.SetParentComponent(cdsProdutosElasticSearch);
    IntegerField1.Name := 'IntegerField1';
    IntegerField1.FieldName := 'id';
    StringField2.SetParentComponent(cdsProdutosElasticSearch);
    StringField2.Name := 'StringField2';
    StringField2.FieldName := 'nome';
    StringField3.SetParentComponent(cdsProdutosElasticSearch);
    StringField3.Name := 'StringField3';
    StringField3.FieldName := 'codigo_barras';
    StringField5.SetParentComponent(cdsProdutosElasticSearch);
    StringField5.Name := 'StringField5';
    StringField5.FieldName := 'imagem';
    dtsProdutosElasticSearch.SetParentComponent(Self);
    dtsProdutosElasticSearch.Name := 'dtsProdutosElasticSearch';
    dtsProdutosElasticSearch.DataSet := cdsProdutosElasticSearch;
    dtsProdutosElasticSearch.Left := 560;
    dtsProdutosElasticSearch.Top := 43;
    XDataWebListaElasticSearch.SetParentComponent(Self);
    XDataWebListaElasticSearch.Name := 'XDataWebListaElasticSearch';
    XDataWebListaElasticSearch.Connection := DMConnection.ApiConnection;
    SetEvent(XDataWebListaElasticSearch, Self, 'OnLoad', 'XDataWebListaElasticSearchLoad');
    SetEvent(XDataWebListaElasticSearch, Self, 'OnError', 'XDataWebListaElasticSearchError');
    XDataWebListaElasticSearch.Left := 568;
    XDataWebListaElasticSearch.Top := 232;
    XDataWebListaElasticSearchCodBarras.SetParentComponent(Self);
    XDataWebListaElasticSearchCodBarras.Name := 'XDataWebListaElasticSearchCodBarras';
    XDataWebListaElasticSearchCodBarras.Connection := DMConnection.ApiConnection;
    SetEvent(XDataWebListaElasticSearchCodBarras, Self, 'OnLoad', 'XDataWebListaElasticSearchCodBarrasLoad');
    SetEvent(XDataWebListaElasticSearchCodBarras, Self, 'OnError', 'XDataWebListaElasticSearchCodBarrasError');
    XDataWebListaElasticSearchCodBarras.Left := 728;
    XDataWebListaElasticSearchCodBarras.Top := 232;
    XDataWebAssociarProdutos.SetParentComponent(Self);
    XDataWebAssociarProdutos.Name := 'XDataWebAssociarProdutos';
    XDataWebAssociarProdutos.Connection := DMConnection.ApiConnection;
    SetEvent(XDataWebAssociarProdutos, Self, 'OnLoad', 'XDataWebAssociarProdutosLoad');
    SetEvent(XDataWebAssociarProdutos, Self, 'OnError', 'XDataWebAssociarProdutosError');
    XDataWebAssociarProdutos.Left := 568;
    XDataWebAssociarProdutos.Top := 296;
  finally
    lbPaginationInfo.AfterLoadDFMValues;
    WebDBTableControl1.AfterLoadDFMValues;
    cbPageSize.AfterLoadDFMValues;
    edSearch.AfterLoadDFMValues;
    lcPaginator.AfterLoadDFMValues;
    btnExportarExcel.AfterLoadDFMValues;
    cbbProdutoStatus.AfterLoadDFMValues;
    cbbProdutoPrecoPadrao.AfterLoadDFMValues;
    cbxProdutosDesativados.AfterLoadDFMValues;
    cbxProdutosExcluidos.AfterLoadDFMValues;
    tblProdutosAssociar.AfterLoadDFMValues;
    btnSelecionadosTab.AfterLoadDFMValues;
    btnMarcarDesmarcarTodos.AfterLoadDFMValues;
    btnPesquisarImagem.AfterLoadDFMValues;
    edtCodigoProduto.AfterLoadDFMValues;
    edtNomeProduto.AfterLoadDFMValues;
    btnSalvarImagem.AfterLoadDFMValues;
    btnRemoverAssociacao.AfterLoadDFMValues;
    tblProdutosElasticSearch.AfterLoadDFMValues;
    edtCodigoProdutoAssociadoModal.AfterLoadDFMValues;
    edtNomeProdutoAssociadoModal.AfterLoadDFMValues;
    edtCodBarrasProdutoAssociadoModal.AfterLoadDFMValues;
    edtProdutosElasticSearch.AfterLoadDFMValues;
    btnPesquisarProdutosElasticSearch.AfterLoadDFMValues;
    btnSolicitarCadastroProduto.AfterLoadDFMValues;
    cbbTipoPesquisa.AfterLoadDFMValues;
    cbPageSizeElasticSearch.AfterLoadDFMValues;
    cbPageSizeSelecionados.AfterLoadDFMValues;
    edtPesquisarSelecionados.AfterLoadDFMValues;
    btnSalvarAlteracoes.AfterLoadDFMValues;
    cbbStatusAssociacao.AfterLoadDFMValues;
    edtCodigoBarrasGerado.AfterLoadDFMValues;
    ProdutosDataset.AfterLoadDFMValues;
    ProdutosDatasetselecionado.AfterLoadDFMValues;
    ProdutosDatasetcodigo_interno.AfterLoadDFMValues;
    ProdutosDatasetassociacaofsprodimagem.AfterLoadDFMValues;
    ProdutosDatasetnome.AfterLoadDFMValues;
    ProdutosDatasetcodigo_barras.AfterLoadDFMValues;
    ProdutosDatasetpreco.AfterLoadDFMValues;
    ProdutosDatasetpromocao.AfterLoadDFMValues;
    ProdutosDatasetpreco_padrao.AfterLoadDFMValues;
    ProdutosDatasetpreco_custo.AfterLoadDFMValues;
    ProdutosDatasetpreco_venda.AfterLoadDFMValues;
    ProdutosDatasetpreco_promocional.AfterLoadDFMValues;
    ProdutosDatasetestoque.AfterLoadDFMValues;
    ProdutosDatasetunidadesigla.AfterLoadDFMValues;
    ProdutosDatasetstatus.AfterLoadDFMValues;
    ProdutosDatasetsubgrupogruponome.AfterLoadDFMValues;
    ProdutosDatasetsubgruponome.AfterLoadDFMValues;
    ProdutosDatasetncmncm.AfterLoadDFMValues;
    ProdutosDatasetcadastro.AfterLoadDFMValues;
    ProdutosDatasetaliadoNome_Fantasia.AfterLoadDFMValues;
    ProdutosDatasetid.AfterLoadDFMValues;
    ProdutosDatasetexcluido.AfterLoadDFMValues;
    ProdutosDatasetinclusao.AfterLoadDFMValues;
    ProdutosDatasetalteracao.AfterLoadDFMValues;
    ProdutosDatasetexclusao.AfterLoadDFMValues;
    ProdutosDatasetassociacaostatus.AfterLoadDFMValues;
    ProdutosDatasetassociacaofsprodnome.AfterLoadDFMValues;
    ProdutosDatasetassociacaofsprodcodigo_barras.AfterLoadDFMValues;
    ProdutosDatasetassociacaoimagem_aprovacao.AfterLoadDFMValues;
    ProdutosDatasetassociacaofsprodid.AfterLoadDFMValues;
    ProdutosDatasetdbassociar_produtos.AfterLoadDFMValues;
    ProdutosDatasetdata_base_id.AfterLoadDFMValues;
    WebDataSource.AfterLoadDFMValues;
    tmrConsulta.AfterLoadDFMValues;
    cdsProdutosAssociar.AfterLoadDFMValues;
    cdsProdutosAssociarcodigo_interno.AfterLoadDFMValues;
    cdsProdutosAssociarnome.AfterLoadDFMValues;
    cdsProdutosAssociarcodigo_barras.AfterLoadDFMValues;
    cdsProdutosAssociarid.AfterLoadDFMValues;
    cdsProdutosAssociarstatus.AfterLoadDFMValues;
    cdsProdutosAssociarimagem.AfterLoadDFMValues;
    cdsProdutosAssociarnome_fs_prod.AfterLoadDFMValues;
    cdsProdutosAssociarcodigo_barras_fs_prod.AfterLoadDFMValues;
    cdsProdutosAssociarsugestao_carregada.AfterLoadDFMValues;
    cdsProdutosAssociarfs_prod_id.AfterLoadDFMValues;
    cdsProdutosAssociaratualizou_status.AfterLoadDFMValues;
    cdsProdutosAssociarimagem_original.AfterLoadDFMValues;
    cdsProdutosAssociarstatus_original.AfterLoadDFMValues;
    cdsProdutosAssociardata_base_id.AfterLoadDFMValues;
    dtsProdutosAssociar.AfterLoadDFMValues;
    XDataWebSugestaoProdutos.AfterLoadDFMValues;
    XDataWebSugestaoImagem.AfterLoadDFMValues;
    cdsProdutosElasticSearch.AfterLoadDFMValues;
    IntegerField1.AfterLoadDFMValues;
    StringField2.AfterLoadDFMValues;
    StringField3.AfterLoadDFMValues;
    StringField5.AfterLoadDFMValues;
    dtsProdutosElasticSearch.AfterLoadDFMValues;
    XDataWebListaElasticSearch.AfterLoadDFMValues;
    XDataWebListaElasticSearchCodBarras.AfterLoadDFMValues;
    XDataWebAssociarProdutos.AfterLoadDFMValues;
  end;
end;

end.

